import { Flashcard } from './flashcards';

// New York: 200 NY-specific + 400 National, 43 duplicates removed = 557 total

export const flashcards: Flashcard[] = [
  {
    id: 1,
    question: "How many hours of qualifying education are currently required for a New York real estate salesperson license?",
    answer: "77 hours of approved qualifying education.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "The New York Department of State currently requires 77 hours of approved salesperson qualifying education before an applicant may qualify for licensure by exam."
  },
  {
    id: 2,
    question: "What are two key requirements, in addition to education and passing the exam, for an initial New York real estate salesperson license?",
    answer: "The applicant must be at least 18 years old and be sponsored by a New York licensed real estate broker.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "New York does not allow a salesperson to practice independently. Broker sponsorship is part of the licensing process."
  },
  {
    id: 3,
    question: "How long is the term of a New York real estate salesperson license?",
    answer: "Two years.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "The Department of State states that the term of licensure for a real estate salesperson in New York is two years."
  },
  {
    id: 4,
    question: "Can a New York real estate salesperson operate independently of a broker?",
    answer: "No. A salesperson must work under the direction and guidance of a responsible licensed broker.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "This is a core New York licensing concept. The broker is responsible for the business, and the salesperson acts through the broker."
  },
  {
    id: 5,
    question: "What is Article 12-A in New York real estate?",
    answer: "It is the section of New York Real Property Law that governs the licensing and regulation of real estate brokers and salespersons.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "New York exam questions often refer directly to Article 12-A, which is the main statutory framework for real estate licensing practice."
  },
  {
    id: 6,
    question: "What is a New York real estate pocket card?",
    answer: "A Department-issued photo identification card showing the licensee's name and business address, and for a salesperson, the broker with whom the salesperson is associated.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "New York law requires pocket cards for licensees, and the card must be shown on demand. This is different from merely having an online license record."
  },
  {
    id: 7,
    question: "How many hours of continuing education are generally required for renewal of a New York real estate salesperson license?",
    answer: "22.5 hours of approved continuing education.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "New York currently requires 22.5 hours for renewal, including mandated topic areas such as fair housing, agency, ethics, cultural competency, implicit bias, and recent legal matters."
  },
  {
    id: 8,
    question: "What is the purpose of New York's buyer and seller agency disclosure form?",
    answer: "To explain the agent's role, the agency relationship being offered, and the rights and obligations that relationship creates.",
    category: "NY Agency and Fair Housing",
    difficulty: "easy",
    explanation: "The form is specifically designed to help buyers and sellers make informed choices about representation."
  },
  {
    id: 9,
    question: "Which fiduciary duties are listed on New York's agency disclosure forms?",
    answer: "Reasonable care, undivided loyalty, confidentiality, full disclosure, obedience, and duty to account.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "These duties are repeatedly tested because they define what an agent owes a client in New York agency relationships."
  },
  {
    id: 10,
    question: "When may a New York real estate broker act as a dual agent?",
    answer: "Only when both parties give informed consent in writing.",
    category: "NY Agency and Fair Housing",
    difficulty: "easy",
    explanation: "New York permits dual agency, but written informed consent is required because dual agency limits the broker's ability to provide undivided loyalty."
  },
  {
    id: 11,
    question: "What is dual agency with designated sales agents in New York?",
    answer: "A dual agency arrangement in which the broker represents both parties, but one sales agent is designated for the buyer and another for the seller, with informed written consent.",
    category: "NY Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Even with designated sales agents, the broker remains a dual agent. This concept is commonly confused with full separate representation, which it is not."
  },
  {
    id: 12,
    question: "What is a broker's agent under New York agency disclosure law?",
    answer: "An agent who cooperates with or is engaged by a listing agent or buyer's agent, but does not work for the same firm, to assist in the transaction.",
    category: "NY Agency and Fair Housing",
    difficulty: "hard",
    explanation: "A broker's agent does not have a direct agency relationship with the buyer or seller. Instead, the broker's agent assists another agent who does have that direct relationship."
  },
  {
    id: 13,
    question: "When must the New York Housing and Anti-Discrimination Disclosure Form be provided?",
    answer: "Upon first substantive contact with a prospective purchaser, tenant, seller, or landlord.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "This timing rule is specific and heavily tested because it reflects New York's strengthened anti-discrimination regulations."
  },
  {
    id: 14,
    question: "How long must a New York broker keep the Housing and Anti-Discrimination Disclosure Form?",
    answer: "Three years from the date of issuance.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "Record-retention questions are common on state exams. New York's fair housing disclosure retention requirement is three years."
  },
  {
    id: 15,
    question: "Where must the New York Fair Housing and Anti-Discrimination Notice be displayed?",
    answer: "In the window of each broker office and branch office, prominently on all licensee websites, and at each open house.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "New York's fair housing display rules are broader than a simple office-posting requirement and extend to websites and open houses."
  },
  {
    id: 16,
    question: "May an unlicensed assistant in New York be paid based on a completed real estate transaction?",
    answer: "No, unless the assistant is licensed as a real estate salesperson and is paid directly by the licensed broker.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Unlicensed assistants may handle clerical support tasks, but transaction-based compensation crosses into licensed activity."
  },
  {
    id: 17,
    question: "Who is responsible for supervising unlicensed assistants in a New York brokerage?",
    answer: "The licensed broker.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "The broker is explicitly responsible for supervision and control of activities conducted in the name of the licensed real estate business."
  },
  {
    id: 18,
    question: "What is a cease and desist zone in New York real estate law?",
    answer: "An area designated by regulation where listed homeowners are protected from prohibited real estate solicitation.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "These zones are intended to address aggressive solicitation. If a homeowner is on the Department's cease and desist list, certain solicitations are prohibited."
  },
  {
    id: 19,
    question: "In a New York cease and desist zone, are 'just listed' or 'just sold' mailings allowed to homeowners on the cease and desist list?",
    answer: "No. Those mailings are considered prohibited solicitation.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "New York guidance specifically treats these mailings, including EDDM-style pieces, as solicitation when directed to homeowners on the list."
  },
  {
    id: 20,
    question: "In New York, what does a buyer typically receive when purchasing a cooperative apartment rather than a condominium unit?",
    answer: "Shares in the cooperative corporation and a proprietary lease, rather than a deed to real property.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This is a classic New York exam distinction. A coop buyer acquires personal property shares plus occupancy rights, while a condo buyer usually receives a deed to the unit."
  },
  {
    id: 21,
    question: "What is a blind ad in New York real estate practice?",
    answer: "An advertisement that fails to identify the real estate broker or brokerage responsible for the ad.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "New York advertising rules are designed to make clear to the public that a licensed brokerage is behind the advertisement. Ads that hide that identity are prohibited."
  },
  {
    id: 22,
    question: "What information must appear on a New York real estate business card?",
    answer: "The business address, the license type, the name of the broker or brokerage, and the office telephone number.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "New York's advertising regulations treat business cards separately and require these core identifying disclosures."
  },
  {
    id: 23,
    question: "Under New York web advertising rules, what must appear on every page of a salesperson or team website, including pages with property search results?",
    answer: "The disclosures required by New York advertising regulations, including the broker or brokerage identification.",
    category: "NY Agency and Fair Housing",
    difficulty: "hard",
    explanation: "The rule does not limit disclosures to the homepage. Search-results pages and other pages must also carry the required brokerage information."
  },
  {
    id: 24,
    question: "If a New York licensee advertises property that is exclusively listed with another broker, what is required?",
    answer: "The licensee must have authorization from the listing broker and clearly identify the exclusive listing broker in the advertisement.",
    category: "NY Agency and Fair Housing",
    difficulty: "hard",
    explanation: "New York specifically regulates ads for another broker's exclusive listing to reduce consumer confusion and prevent misleading lead capture."
  },
  {
    id: 25,
    question: "How long must a New York licensed broker generally keep transaction records for covered residential sales transactions?",
    answer: "Three years.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "Under New York record-retention rules, brokers must maintain required transaction records, which may be kept in paper or electronic form, for three years."
  },
  {
    id: 26,
    question: "Beginning July 1, 2025, what New York form is required in covered residential sales transactions?",
    answer: "The Property Condition Disclosure Statement.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "New York's Department of State identifies the Property Condition Disclosure Statement as a required form beginning July 1, 2025."
  },
  {
    id: 27,
    question: "In a New York cooperative purchase, who often has the power to approve or reject a prospective purchaser?",
    answer: "The cooperative corporation's board.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Board approval is a defining practical feature of many coop transactions and a major distinction from typical condominium ownership."
  },
  {
    id: 28,
    question: "What is a right of first refusal in the context of many condominium transactions?",
    answer: "A right allowing the condominium association or another designated party to match an outside offer before the sale proceeds to that outside buyer.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This concept appears in the New York syllabus because buyers and agents must understand how condo governing documents can affect transfer rights."
  },
  {
    id: 29,
    question: "What is a mortgage recording tax in New York?",
    answer: "A tax imposed when a mortgage is recorded, commonly treated as a buyer or borrower closing cost.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "New York closings commonly test whether students recognize the mortgage recording tax as a transaction cost tied to recording the mortgage, not merely to buying property."
  },
  {
    id: 30,
    question: "What is a mortgage commitment?",
    answer: "A lender's written promise to make a loan, subject to stated terms and conditions.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "On the exam, a commitment is stronger than a casual prequalification because it reflects an underwriting decision subject to remaining conditions."
  },
  {
    id: 31,
    question: "What is the difference between prequalification and preapproval?",
    answer: "Prequalification is an informal estimate of borrowing ability, while preapproval is a more detailed lender review indicating the borrower appears eligible subject to final conditions.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Exam questions often test whether the candidate understands that preapproval generally carries more weight in a transaction than prequalification."
  },
  {
    id: 32,
    question: "What is the loan-to-value ratio?",
    answer: "The loan amount divided by the property's value or purchase price, expressed as a percentage.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "LTV is a key underwriting measure because it shows how much of the property's value is being financed rather than covered by the buyer's equity."
  },
  {
    id: 33,
    question: "What is net operating income (NOI) for an income-producing property?",
    answer: "Income remaining after operating expenses are subtracted from gross income, but before debt service and income taxes.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "NOI is central to valuing investment property because it isolates the property's operating performance from the owner's financing choices."
  },
  {
    id: 34,
    question: "What is the capitalization rate formula used in basic real estate investment analysis?",
    answer: "Capitalization rate equals net operating income divided by value or price.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "The cap rate connects income to value. A property producing higher NOI relative to price has a higher cap rate."
  },
  {
    id: 35,
    question: "What is the gross rent multiplier (GRM)?",
    answer: "A rough valuation tool found by dividing a property's sale price by its gross rental income.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "GRM is a quick screening method rather than a full appraisal technique because it ignores vacancy, expenses, and financing."
  },
  {
    id: 36,
    question: "What is depreciation for income tax purposes in real estate?",
    answer: "A tax deduction that allocates the cost of qualifying improvements over time to reflect wear, obsolescence, or useful life decline.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Land is not depreciated because it is not considered to wear out in the same way as buildings and other eligible improvements."
  },
  {
    id: 37,
    question: "What is a tax-deferred exchange under Section 1031 generally used for?",
    answer: "To defer recognition of capital gain when qualifying investment or business property is exchanged for other qualifying property.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "The exam usually tests the broad purpose of a 1031 exchange rather than advanced structuring details: deferral, not permanent elimination, of gain."
  },
  {
    id: 38,
    question: "What is a special assessment in real estate taxation?",
    answer: "A charge imposed on property to pay for a public improvement that specially benefits that property.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "Unlike a general property tax, a special assessment is tied to a particular improvement such as sidewalks, sewers, or paving."
  },
  {
    id: 39,
    question: "What does the STAR program generally relate to in New York real estate taxation?",
    answer: "A school tax relief program that can reduce the property tax burden for qualifying homeowners.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "STAR is a recurring New York-specific exam topic because it appears within the state tax-and-assessment portion of the syllabus."
  },
  {
    id: 40,
    question: "What is the purpose of New York's State Environmental Quality Review process in land use matters?",
    answer: "To evaluate environmental impacts of certain actions before approvals or decisions are made.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "The New York syllabus includes State Environmental Quality Review because licensees should understand that environmental review can affect development timing and land-use decisions."
  },
  {
    id: 41,
    question: "What is 'as-of-right' zoning?",
    answer: "A use of property that is permitted under current zoning without the need for a variance or special approval.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This is a common land-use exam concept because it contrasts with uses that require discretionary approval from local boards."
  },
  {
    id: 42,
    question: "What is the primary role of a local planning board in New York land use regulation?",
    answer: "To review and guide land development matters such as subdivision plats, site planning, and long-range community planning.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "The syllabus emphasizes knowing which local body handles planning functions as opposed to tax assessment, zoning enforcement, or appeals."
  },
  {
    id: 43,
    question: "What is the primary role of a zoning board of appeals?",
    answer: "To hear appeals and requests for relief from zoning requirements, such as variances.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "This board is tested as distinct from the planning board. Candidates should know it handles zoning relief rather than ordinary tax or building administration."
  },
  {
    id: 44,
    question: "Who typically determines assessed value for local real property taxation in New York?",
    answer: "The tax assessor or assessor's office.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "The syllabus specifically identifies the tax assessor as a key local official because assessment questions are central to New York property taxation."
  },
  {
    id: 45,
    question: "If a property owner believes a New York assessment is unequal or excessive, what local body commonly hears the grievance?",
    answer: "The grievance board, sometimes called the board of assessment review.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "The New York syllabus includes protesting assessments, so candidates should know the typical local review path before further legal proceedings."
  },
  {
    id: 46,
    question: "What is a variance in land use regulation?",
    answer: "Permission to deviate from the literal terms of a zoning ordinance when strict enforcement would create qualifying hardship under the law.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "A variance is a common exam concept because it reflects an exception to zoning, not a permanent rewriting of the ordinance itself."
  },
  {
    id: 47,
    question: "What is a deed restriction?",
    answer: "A private limitation placed in a deed that restricts how the property may be used.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "The New York syllabus treats deed restrictions as private land-use controls, which differ from public restrictions such as zoning."
  },
  {
    id: 48,
    question: "What is a satisfaction of mortgage?",
    answer: "A document showing that the mortgage debt has been paid and the lien should be released from the property record.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This concept is important at closing because paying off a loan is not enough by itself; the public record should also reflect that the lien has been satisfied."
  },
  {
    id: 49,
    question: "What is a typical purpose of escrowed property taxes and insurance in a residential mortgage loan?",
    answer: "To allow the lender to collect monthly amounts and pay those major property-related expenses when due.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "The NY syllabus ties property insurance and taxes to financing because lenders often require escrow accounts to protect their security interest."
  },
  {
    id: 50,
    question: "What is the difference between actual cash value and replacement cost in property insurance?",
    answer: "Actual cash value reflects depreciation, while replacement cost pays the cost to replace covered property without deducting depreciation, subject to policy terms.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "This is a core insurance distinction in the syllabus because buyers need to understand that cheaper coverage may leave them underinsured after a loss."
  },
  {
    id: 51,
    question: "Which homeowners policy form is commonly associated with condominium unit owners?",
    answer: "An HO-6 condominium owners policy.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "The New York syllabus specifically identifies HO-6 as the standard policy form associated with condo ownership."
  },
  {
    id: 52,
    question: "Which homeowners policy form is commonly associated with tenants or cooperative owners?",
    answer: "An HO-4 tenants or cooperative owners policy.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "The syllabus distinguishes HO-4 from HO-6. This is especially relevant in New York because cooperative ownership is a major exam topic."
  },
  {
    id: 53,
    question: "What is the National Flood Insurance Program generally designed to provide?",
    answer: "Flood insurance coverage for eligible properties because flood loss is usually excluded from standard property insurance policies.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Flood coverage is tested separately because many buyers incorrectly assume ordinary homeowners insurance covers flood damage."
  },
  {
    id: 54,
    question: "What is property management in real estate practice?",
    answer: "The operation, control, and oversight of real property on behalf of the owner to protect value and meet ownership goals.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Property management appears as its own subject in the New York syllabus because licensees often work with income-producing property after acquisition as well as at sale."
  },
  {
    id: 55,
    question: "What is the difference between preventive maintenance and emergency maintenance in property management?",
    answer: "Preventive maintenance is scheduled work intended to avoid breakdowns, while emergency maintenance responds to urgent problems that threaten safety or property.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This is a practical management distinction because good preventive maintenance helps reduce costly emergencies and preserve owner income."
  },
  {
    id: 56,
    question: "What is the operating budget in property management?",
    answer: "A projection of income and expenses used to plan, control, and evaluate property operations over a stated period.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Operating budgets matter because owners and managers rely on them to track performance, forecast cash needs, and measure whether the property is meeting expectations."
  },
  {
    id: 57,
    question: "What is the difference between a mortgage broker and a mortgage banker?",
    answer: "A mortgage broker arranges loans for borrowers through lenders, while a mortgage banker typically funds or closes loans in the banker's own name or through its own lending channel.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "The New York syllabus includes this comparison because students often confuse arranging a loan with actually making or funding one."
  },
  {
    id: 58,
    question: "What is RESPA primarily designed to regulate in residential real estate transactions?",
    answer: "Settlement and closing practices, including required disclosures and restrictions on certain kickbacks and referral fees.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "RESPA is a recurring finance and closing topic because it protects consumers in federally related mortgage transactions."
  },
  {
    id: 59,
    question: "What does the New York syllabus identify as the real estate licensee's role in safety?",
    answer: "To use prudent safety practices such as knowing surroundings, controlling office access, preparing for open-house risks, and maintaining personal awareness in the field.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "The safety unit is not trivia. It is included because licensees routinely meet strangers, enter vacant property, and work outside normal office controls."
  },
  {
    id: 60,
    question: "If a property is assessed at 80% of market value and has a market value of $500,000, what is the assessed value?",
    answer: "$400,000.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Assessed value equals market value multiplied by the assessment ratio. Here, $500,000 x 0.80 = $400,000."
  },
  {
    id: 61,
    question: "What is an executory contract in a real estate transaction?",
    answer: "A contract that has been signed by the parties but has not yet been fully performed.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "A contract of sale is usually executory from signing until closing because obligations remain to be completed."
  },
  {
    id: 62,
    question: "What is specific performance as a contract remedy?",
    answer: "A court order requiring a party to carry out the contract as agreed rather than simply paying money damages.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Because each parcel of real estate is considered unique, specific performance is a common remedy concept in real estate exam questions."
  },
  {
    id: 63,
    question: "What is the purpose of a contingency clause in a real estate contract?",
    answer: "To make the contract dependent on the occurrence or nonoccurrence of a stated event, such as financing or inspection.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Contingencies allocate risk and provide a lawful way for parties to proceed only if certain conditions are satisfied."
  },
  {
    id: 64,
    question: "What is liquidated damages in a real estate contract?",
    answer: "An amount agreed in advance that may be retained or paid if a party breaches the contract.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Earnest money is often discussed in this context because the contract may specify whether the deposit can serve as liquidated damages."
  },
  {
    id: 65,
    question: "What is a bilateral contract?",
    answer: "A contract in which both parties make promises to each other.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Most contracts for the sale of real estate are bilateral because the seller promises to convey title and the buyer promises to pay."
  },
  {
    id: 66,
    question: "What is an estate for years?",
    answer: "A leasehold estate that has a definite beginning date and a definite ending date.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Despite the name, it can last for any fixed period, including days or months, as long as the end date is definite."
  },
  {
    id: 67,
    question: "What is a periodic tenancy?",
    answer: "A leasehold that continues for successive periods, such as month to month, until properly terminated by notice.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Periodic tenancies automatically renew for another period unless one party gives the required notice."
  },
  {
    id: 68,
    question: "What is a percentage lease?",
    answer: "A commercial lease in which the tenant pays base rent plus a percentage of business revenue.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This lease structure is common in retail settings and fits the commercial leasing portion of the New York syllabus."
  },
  {
    id: 69,
    question: "What is a gross lease?",
    answer: "A lease in which the tenant pays a fixed rent and the landlord pays most or all of the operating expenses.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Exam questions often compare this with net leases, where the tenant pays some or all of the property's operating costs."
  },
  {
    id: 70,
    question: "What is a net lease?",
    answer: "A lease in which the tenant pays rent plus some or all of the property's operating expenses, such as taxes, insurance, or maintenance.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Commercial leasing questions commonly test whether students understand how expense burdens shift between landlord and tenant."
  },
  {
    id: 71,
    question: "What is the sales comparison approach to value?",
    answer: "An appraisal method that estimates value by comparing the subject property to recently sold similar properties and adjusting for differences.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "This is generally the most relevant approach for owner-occupied residential property because it reflects how buyers and sellers behave in the market."
  },
  {
    id: 72,
    question: "What is the cost approach to value?",
    answer: "An appraisal method that estimates value by adding land value to the cost of replacing or reproducing improvements, minus depreciation.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "The cost approach is often useful for newer properties or special-purpose buildings when there are limited comparable sales."
  },
  {
    id: 73,
    question: "What is the income approach to value?",
    answer: "An appraisal method that estimates value based on the income a property can produce.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "This approach is especially important for investment and commercial property because buyers focus on expected income performance."
  },
  {
    id: 74,
    question: "What is functional obsolescence?",
    answer: "A loss in value caused by defects in design, layout, or utility within the property itself.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Examples include an outdated floor plan or insufficient bathrooms. It differs from external obsolescence, which comes from outside influences."
  },
  {
    id: 75,
    question: "What is economic or external obsolescence?",
    answer: "A loss in value caused by factors outside the property, such as nearby nuisances, declining neighborhood conditions, or adverse zoning changes.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Because the cause is outside the property, it is usually less curable than physical deterioration or some forms of functional obsolescence."
  },
  {
    id: 76,
    question: "What is the antitrust concept of price fixing in real estate?",
    answer: "An unlawful agreement among competitors to set prices, commission rates, or fees rather than allowing the market to determine them.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "Commission rates must always be negotiable. Any agreement among competing firms to standardize rates creates serious antitrust risk."
  },
  {
    id: 77,
    question: "What is blockbusting?",
    answer: "An illegal practice of inducing owners to sell by suggesting that protected-class members are moving into the area and property values will decline.",
    category: "NY Agency and Fair Housing",
    difficulty: "easy",
    explanation: "This is a classic fair housing violation and remains highly testable because it combines discrimination and unethical solicitation."
  },
  {
    id: 78,
    question: "Why is steering illegal in real estate practice?",
    answer: "Because directing buyers or renters toward or away from neighborhoods based on protected characteristics is discriminatory housing conduct.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "Steering limits housing choice on an unlawful basis and violates fair housing principles even if the agent claims to be helping the client."
  },
  {
    id: 79,
    question: "What is radon?",
    answer: "A naturally occurring radioactive gas that can accumulate in buildings and create health risks.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Radon is colorless and odorless, which is why testing matters. It is a standard environmental hazard topic on many state exam outlines."
  },
  {
    id: 80,
    question: "What is asbestos and why is it significant in real estate?",
    answer: "Asbestos is a mineral fiber once used in building materials that can create health hazards if disturbed and inhaled.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Older buildings may contain asbestos in insulation, flooring, or other materials. The exam typically tests recognition of the hazard rather than technical abatement procedures."
  },
  {
    id: 81,
    question: "What is marketable title?",
    answer: "Title that is reasonably free from significant defects and would be accepted by a well-informed purchaser or lender.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "At closing, buyers generally expect marketable title rather than title burdened by serious defects, undisclosed liens, or unresolved ownership issues."
  },
  {
    id: 82,
    question: "What is the primary purpose of title insurance?",
    answer: "To protect against losses from title defects, liens, or ownership problems that were not discovered before closing.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Unlike hazard insurance, title insurance protects against past events affecting ownership rather than future physical damage to the property."
  },
  {
    id: 83,
    question: "What is a deed?",
    answer: "A written instrument used to transfer an interest in real property from a grantor to a grantee.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "A contract of sale creates obligations, but the deed is the document that actually conveys title at closing."
  },
  {
    id: 84,
    question: "What is the difference between a general warranty deed and a quitclaim deed?",
    answer: "A general warranty deed provides broad covenants of title, while a quitclaim deed transfers only whatever interest the grantor has, if any, without those promises.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This is a classic deed question because it tests the difference between conveying ownership with title assurances and conveying possible interest without warranties."
  },
  {
    id: 85,
    question: "What is a grantor?",
    answer: "The person or entity transferring an interest in real property.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "The grantor conveys title, while the grantee receives it. These terms appear frequently in deed questions."
  },
  {
    id: 86,
    question: "What is a grantee?",
    answer: "The person or entity receiving an interest in real property.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "The exam often tests grantor and grantee terminology because it is foundational to deed transfer questions."
  },
  {
    id: 87,
    question: "What is constructive notice in real estate?",
    answer: "Notice the public is presumed to have because information is available in the public record, such as properly recorded documents.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Recording statutes matter because buyers and lenders are treated as though they know what the public record reveals."
  },
  {
    id: 88,
    question: "What is actual notice?",
    answer: "Direct knowledge of a fact, such as knowing about an unrecorded claim or learning of it through direct communication.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Actual notice differs from constructive notice because the person truly knows the fact rather than being charged with knowledge from the record."
  },
  {
    id: 89,
    question: "What is a lis pendens?",
    answer: "A recorded notice that litigation is pending which may affect title to or possession of real property.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "This is important because it warns potential buyers or lenders that the property's title may be affected by an ongoing court case."
  },
  {
    id: 90,
    question: "What is the equity of redemption?",
    answer: "The borrower's right to reclaim property before a foreclosure sale by paying the debt and required costs.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Equity of redemption is a common foreclosure concept because it exists before the foreclosure sale is completed."
  },
  {
    id: 91,
    question: "What is a deficiency judgment in foreclosure?",
    answer: "A court judgment against the borrower for the amount still owed if the foreclosure sale proceeds do not fully satisfy the debt.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This question tests whether the student understands that foreclosure sale proceeds may be less than the mortgage balance."
  },
  {
    id: 92,
    question: "What is a mechanic's lien?",
    answer: "A lien filed by someone who provided labor or materials for the improvement of property and was not paid.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Mechanic's liens are common exam material because they illustrate involuntary liens arising from property improvement work."
  },
  {
    id: 93,
    question: "What is amortization in mortgage lending?",
    answer: "The gradual repayment of a loan through periodic payments of principal and interest over time.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "An amortized loan steadily reduces the balance, unlike an interest-only structure that delays principal reduction."
  },
  {
    id: 94,
    question: "What is negative amortization?",
    answer: "A situation in which loan payments are not large enough to cover all interest due, causing the principal balance to increase.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "This concept is tested because it reverses the normal expectation that regular payments reduce the debt over time."
  },
  {
    id: 95,
    question: "What is discounting a note?",
    answer: "Selling a promissory note for less than its face amount in order to receive cash immediately.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "The note holder accepts less than the full future value in exchange for present cash, reflecting time value and risk."
  },
  {
    id: 96,
    question: "If a lender makes a $360,000 loan at 90% loan-to-value, what is the property's value or purchase price?",
    answer: "$400,000.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Value equals loan amount divided by LTV. Here, $360,000 / 0.90 = $400,000."
  },
  {
    id: 97,
    question: "If annual property taxes are $9,600, what is the monthly escrow amount for taxes alone?",
    answer: "$800 per month.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "Monthly escrow for annual taxes is found by dividing by 12. Here, $9,600 / 12 = $800."
  },
  {
    id: 98,
    question: "What is the right of survivorship?",
    answer: "The feature of certain co-ownership forms under which a deceased owner's interest passes automatically to the surviving co-owner or co-owners.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "This concept distinguishes joint tenancy and tenancy by the entirety from tenancy in common."
  },
  {
    id: 99,
    question: "What is dower or curtesy in a historical property-rights context?",
    answer: "Traditional common-law spousal rights in a deceased spouse's real property, concepts that are important mainly as historical background in modern exam study.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "hard",
    explanation: "These concepts appear on some exam outlines as historical property-rights terminology even though modern statutes often replaced them."
  },
  {
    id: 100,
    question: "Why must a New York real estate licensee avoid making unauthorized legal interpretations of contracts or title issues?",
    answer: "Because giving legal advice beyond the licensee's role can constitute unauthorized practice of law and expose the parties and licensee to risk.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "A real estate licensee may explain business terms and transaction process, but legal conclusions about rights or enforceability belong to attorneys."
  },
  {
    id: 101,
    question: "What is a suspension of a real estate license?",
    answer: "A temporary loss of the legal right to practice real estate during the suspension period.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "Suspension differs from revocation because the license may become active again after the suspension ends and any required conditions are satisfied."
  },
  {
    id: 102,
    question: "What is revocation of a real estate license?",
    answer: "The termination of a licensee's authority to practice real estate due to disciplinary action.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "Revocation is more severe than suspension because the license is taken away rather than paused."
  },
  {
    id: 103,
    question: "What is censure in a real estate disciplinary context?",
    answer: "A formal reprimand issued by the licensing authority for misconduct.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "Censure is disciplinary action even when the license is not fully suspended or revoked."
  },
  {
    id: 104,
    question: "What is a material fact in a real estate transaction?",
    answer: "A fact that could affect a reasonable person's decision to buy, sell, lease, or finance the property.",
    category: "NY Agency and Fair Housing",
    difficulty: "easy",
    explanation: "Material facts matter because licensees must avoid concealment and misrepresentation in transactions."
  },
  {
    id: 105,
    question: "What is stigmatized property in New York real estate practice?",
    answer: "Property that may be viewed negatively for reasons unrelated to physical condition, such as prior events or occupant history.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "New York treats some stigma-related issues differently from physical defects, making this a state-specific disclosure concept."
  },
  {
    id: 106,
    question: "What is the federal Lead-Based Paint Hazard Reduction Act primarily concerned with?",
    answer: "Disclosure of known lead-based paint hazards in many pre-1978 residential properties.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Lead-based paint is a major federal disclosure topic that appears in state exam prep because it affects ordinary residential transactions."
  },
  {
    id: 107,
    question: "For many covered pre-1978 residential sales, what lead-paint information must be given to the buyer before closing?",
    answer: "The buyer must receive the lead warning statement, any known lead-based paint information and records, and the EPA-approved pamphlet.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This question tests transaction procedure, not just hazard recognition. The disclosure package must be delivered before the buyer becomes obligated under the contract."
  },
  {
    id: 108,
    question: "What is the purpose of the federal Fair Housing Act?",
    answer: "To prohibit discrimination in housing-related transactions based on protected characteristics.",
    category: "NY Agency and Fair Housing",
    difficulty: "easy",
    explanation: "New York exam prep includes federal fair housing because state licensees must comply with both federal and state anti-discrimination rules."
  },
  {
    id: 109,
    question: "What is redlining in a fair housing context?",
    answer: "The illegal practice of denying or limiting loans or insurance in certain areas based on discriminatory factors rather than legitimate underwriting.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "Redlining is tested as a discriminatory housing practice that can affect lending, insurance, and access to housing opportunity."
  },
  {
    id: 110,
    question: "What is reasonable accommodation in a fair housing setting?",
    answer: "A change to rules, policies, practices, or services that may be necessary to give a person with a disability equal housing opportunity.",
    category: "NY Agency and Fair Housing",
    difficulty: "hard",
    explanation: "This concept is distinct from a reasonable modification, which is a physical change to the premises."
  },
  {
    id: 111,
    question: "What is reasonable modification in a fair housing setting?",
    answer: "A structural or physical change to a dwelling that may be necessary for a person with a disability to fully use and enjoy the premises.",
    category: "NY Agency and Fair Housing",
    difficulty: "hard",
    explanation: "Students commonly confuse modification with accommodation. Modification changes the property itself; accommodation changes rules or services."
  },
  {
    id: 112,
    question: "What is a security deposit in a residential lease?",
    answer: "Money held by the landlord to secure the tenant's performance of lease obligations, subject to applicable law.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Security deposit questions usually focus on purpose, accounting, and lawful handling rather than calling the deposit 'last month's rent' by default."
  },
  {
    id: 113,
    question: "What is the difference between ordinary wear and tear and damage in a rental property?",
    answer: "Ordinary wear and tear is normal deterioration from regular use, while damage results from abuse, negligence, or misuse.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This distinction matters because routine aging is generally treated differently from tenant-caused harm when evaluating condition and charges."
  },
  {
    id: 114,
    question: "What is a rent roll in property management?",
    answer: "A record listing rental units, tenants, rent amounts, and related lease information for an income-producing property.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "A rent roll is a core management and underwriting document because it shows current occupancy and income structure."
  },
  {
    id: 115,
    question: "What is a Certificate of Occupancy generally used to show?",
    answer: "That a building or space has been approved for occupancy or use under applicable building and code requirements.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This is a practical closing and land-use concept because use of a property may depend on whether the permitted occupancy matches the intended use."
  },
  {
    id: 116,
    question: "What is the purpose of a title search before closing?",
    answer: "To examine the public record for defects, liens, encumbrances, and ownership issues that could affect title.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "The title search helps identify problems before conveyance so they can be cleared, insured over when appropriate, or disclosed."
  },
  {
    id: 117,
    question: "If a commission is 5% of a $680,000 sale price, what is the total commission?",
    answer: "$34,000.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "Commission equals sale price multiplied by commission rate. Here, $680,000 x 0.05 = $34,000."
  },
  {
    id: 118,
    question: "If two brokers split a $34,000 commission equally, how much does each broker receive before any internal brokerage splits?",
    answer: "$17,000 each.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "An equal split means dividing the total commission by two. Here, $34,000 / 2 = $17,000."
  },
  {
    id: 119,
    question: "What is prorating at a closing?",
    answer: "Allocating expenses or income between buyer and seller according to the period each is responsible for or benefits from.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Common prorations include taxes, rents, interest, and association charges. The goal is to fairly divide amounts as of the closing date."
  },
  {
    id: 120,
    question: "What is the closing statement in a real estate transaction?",
    answer: "The accounting of debits, credits, and amounts due from or to the parties at closing.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "The closing statement summarizes the transaction financially and shows how the final cash required or proceeds were calculated."
  },
  {
    id: 121,
    question: "What is earnest money in a real estate transaction?",
    answer: "A deposit made by a buyer to show good faith and support the purchase offer.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Earnest money is not the same as a down payment at closing, though it is often credited toward the buyer's obligations if the transaction closes."
  },
  {
    id: 122,
    question: "What is a balloon payment in mortgage financing?",
    answer: "A large final payment due at the end of a loan term after smaller periodic payments have been made.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Balloon loans are tested because they can create payment shock when the remaining principal comes due in one lump sum."
  },
  {
    id: 123,
    question: "What is an acceleration clause in a mortgage?",
    answer: "A provision allowing the lender to declare the full loan balance immediately due upon default.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Acceleration is an important pre-foreclosure concept because it changes the borrower's obligation from installment payments to the full unpaid balance."
  },
  {
    id: 124,
    question: "What is a prepayment penalty?",
    answer: "A charge some loans impose if the borrower pays off the loan earlier than the lender expected.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "The concept matters because early payoff can reduce the lender's expected interest income."
  },
  {
    id: 125,
    question: "What is an assumption of a mortgage?",
    answer: "A transaction in which a buyer takes over responsibility for an existing mortgage debt, subject to lender and contract terms.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Assumption differs from taking title 'subject to' a loan because assumption involves personal responsibility for the debt."
  },
  {
    id: 126,
    question: "What does taking title 'subject to' an existing mortgage generally mean?",
    answer: "The buyer takes ownership while the mortgage remains on the property, but the buyer does not formally assume personal liability for the debt.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "The property can still be foreclosed if the debt is not paid, even though the buyer may not have assumed personal liability."
  },
  {
    id: 127,
    question: "What is a due-on-sale clause?",
    answer: "A mortgage provision allowing the lender to demand full repayment if the property is transferred without the lender's consent.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This clause is tested with assumptions and transfers because it can prevent a buyer from simply stepping into an existing loan."
  },
  {
    id: 128,
    question: "What is a package mortgage?",
    answer: "A loan that covers both real property and personal property in the same financing arrangement.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "Package mortgages appear on licensing exams because they test whether students can distinguish collateral types within one loan structure."
  },
  {
    id: 129,
    question: "What is a purchase-money mortgage?",
    answer: "A mortgage given by a buyer to a seller as part of the purchase financing.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "This is seller financing. The seller helps finance the purchase instead of or in addition to institutional lending."
  },
  {
    id: 130,
    question: "What is a deed in lieu of foreclosure?",
    answer: "A transfer in which the borrower gives the property to the lender to avoid the foreclosure process.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This can save time and expense, but the lender must be willing to accept the deed and evaluate any junior liens or title issues."
  },
  {
    id: 131,
    question: "What is a judgment lien?",
    answer: "An involuntary lien that may attach to a debtor's property after a court judgment is entered and properly recorded or docketed.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Judgment liens are common test material because they arise by operation of law rather than by the owner's voluntary agreement."
  },
  {
    id: 132,
    question: "What is actual eviction?",
    answer: "The physical or legal removal of a tenant from possession of leased premises.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Actual eviction differs from constructive eviction, where the tenant leaves because the premises have become unusable through the landlord's actions or failure to act."
  },
  {
    id: 133,
    question: "What is constructive eviction?",
    answer: "A situation in which the landlord's action or inaction makes the premises unfit for intended use, causing the tenant to leave.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "Constructive eviction is a legal concept often tested because the tenant is not forcibly removed but effectively driven out by conditions."
  },
  {
    id: 134,
    question: "What is the percentage of gain if a property purchased for $400,000 later sells for $460,000 before transaction costs?",
    answer: "15%.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Gain is $60,000. Divide $60,000 by the original $400,000 cost to get 0.15, or 15%."
  },
  {
    id: 135,
    question: "If a property has an annual net operating income of $48,000 and a capitalization rate of 8%, what is the indicated value?",
    answer: "$600,000.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Value equals NOI divided by capitalization rate. Here, $48,000 / 0.08 = $600,000."
  },
  {
    id: 136,
    question: "What is appreciation?",
    answer: "An increase in property value over time due to market forces, improvements, or other positive factors.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "Appreciation is the opposite of depreciation in a broad market sense, though tax depreciation has a different technical meaning."
  },
  {
    id: 137,
    question: "What is plottage value?",
    answer: "The increase in value created by combining two or more adjacent parcels into one larger parcel.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Plottage is a classic licensing-exam term, especially in urban and development contexts where assemblage can create greater utility and value."
  },
  {
    id: 138,
    question: "What is assemblage in real estate?",
    answer: "The process of combining two or more contiguous parcels under common ownership or control.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Assemblage is the process; plottage is the resulting increase in value if the assembled parcel becomes more useful or marketable."
  },
  {
    id: 139,
    question: "What is the purpose of an exclusive right-to-sell listing?",
    answer: "To give one broker the right to market the property and earn a commission if the property sells during the listing term, regardless of who finds the buyer.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "This is the most protective listing for the broker because the owner usually still owes the commission even if the owner personally finds the buyer."
  },
  {
    id: 140,
    question: "What is an exclusive agency listing?",
    answer: "A listing in which one broker represents the seller, but the seller may avoid paying a commission if the seller alone procures the buyer.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This differs from an exclusive right-to-sell listing because the seller retains the right to sell without paying the broker if no broker is the procuring cause."
  },
  {
    id: 141,
    question: "What is an open listing?",
    answer: "A nonexclusive listing in which the seller may use multiple brokers and owes a commission only to the broker who is the procuring cause of the sale.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "An open listing offers the least protection to a broker because the seller can work with several brokers or even sell without owing a commission to a broker who was not the procuring cause."
  },
  {
    id: 142,
    question: "What is procuring cause in a brokerage transaction?",
    answer: "The broker or agent whose efforts set in motion an uninterrupted chain of events that results in the completed transaction.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This concept often determines commission entitlement, especially in disputes involving multiple brokers or open listings."
  },
  {
    id: 143,
    question: "What is net listing terminology generally associated with?",
    answer: "A listing arrangement in which the owner seeks a set net amount and the broker keeps any excess as compensation, a structure that creates serious conflict-of-interest concerns.",
    category: "NY License Law and Professional Practice",
    difficulty: "hard",
    explanation: "Exam questions typically focus on the ethical risk because the broker's incentive may diverge from the owner's best interests."
  },
  {
    id: 144,
    question: "What duty does an agent owe a customer even when no fiduciary agency relationship exists?",
    answer: "Honest dealing, fair dealing, and disclosure of known material facts.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "An agent's full fiduciary duties run to the client, but licensees still owe lawful and truthful conduct to all parties in the transaction."
  },
  {
    id: 145,
    question: "What is a fiduciary?",
    answer: "A person in a position of trust who must act in the best interests of the party represented.",
    category: "NY Agency and Fair Housing",
    difficulty: "easy",
    explanation: "This is the core agency concept behind loyalty, confidentiality, obedience, accounting, reasonable care, and disclosure."
  },
  {
    id: 146,
    question: "What is latent defect disclosure in real estate?",
    answer: "Disclosure of a hidden defect known to the seller or licensee that is not readily observable and could materially affect value or safety.",
    category: "NY Agency and Fair Housing",
    difficulty: "medium",
    explanation: "A latent defect differs from a patent defect because it is not obvious on ordinary inspection."
  },
  {
    id: 147,
    question: "What is a patent defect?",
    answer: "A defect that is readily observable or discoverable by ordinary inspection.",
    category: "NY Agency and Fair Housing",
    difficulty: "easy",
    explanation: "Patent and latent defects are often tested together because students must distinguish obvious conditions from hidden ones."
  },
  {
    id: 148,
    question: "What is the purpose of maintaining transaction records in a real estate brokerage?",
    answer: "To document compliance, protect the parties, support audits or investigations, and preserve an accurate history of the transaction.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "Recordkeeping is not just administrative. It is essential for proving what occurred and whether the brokerage followed legal requirements."
  },
  {
    id: 149,
    question: "What is commingling in brokerage practice?",
    answer: "Improperly mixing client or escrow funds with a broker's personal or business funds.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Commingling is a major discipline topic because client funds must be protected from the broker's operating money and personal use."
  },
  {
    id: 150,
    question: "What is conversion in brokerage practice?",
    answer: "Wrongfully using client or escrow funds for the broker's own purposes.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Conversion is more serious than mere commingling because it involves unauthorized use of the money, not just improper placement."
  },
  {
    id: 151,
    question: "What is puffing in real estate advertising?",
    answer: "Exaggerated opinion or sales talk that is not meant as a factual representation.",
    category: "NY Agency and Fair Housing",
    difficulty: "easy",
    explanation: "Puffing is generally contrasted with misrepresentation. Saying a home has 'the best view in town' is different from misstating a measurable fact."
  },
  {
    id: 152,
    question: "What is misrepresentation in real estate practice?",
    answer: "A false statement or misleading omission of a material fact that induces another person to act.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "Misrepresentation can lead to civil liability, disciplinary action, or both, especially when it involves a material fact."
  },
  {
    id: 153,
    question: "What is fraud in a real estate context?",
    answer: "An intentional misrepresentation or concealment of a material fact made to induce another person to rely on it.",
    category: "NY License Law and Professional Practice",
    difficulty: "hard",
    explanation: "Fraud typically requires intent, which distinguishes it from negligent error or innocent misstatement."
  },
  {
    id: 154,
    question: "What is the purpose of a building permit?",
    answer: "To authorize construction, alteration, or improvement work under applicable building and safety codes.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "A building permit is distinct from zoning approval or a certificate of occupancy, though all may affect a property's legal use."
  },
  {
    id: 155,
    question: "What is a nonconforming use in zoning?",
    answer: "A lawful existing use that no longer conforms to current zoning but may continue under applicable rules.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This concept is common in zoning questions because it shows how prior lawful uses may survive later zoning changes."
  },
  {
    id: 156,
    question: "What is spot zoning?",
    answer: "Zoning treatment applied to a small parcel differently from surrounding property in a way that may favor a particular owner rather than the public plan.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "hard",
    explanation: "This term is tested because it contrasts with legitimate comprehensive zoning based on community-wide planning."
  },
  {
    id: 157,
    question: "What is a variance most commonly intended to address: use restrictions, area restrictions, or both depending on the facts and law?",
    answer: "Both can be addressed depending on the facts and the type of variance allowed under the law.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "hard",
    explanation: "Students often oversimplify variance questions. The exam may distinguish area variances from use variances, both of which are forms of zoning relief."
  },
  {
    id: 158,
    question: "What is an abstract of title?",
    answer: "A summary of the recorded history affecting title to a parcel of real property.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Historically, abstracts were used to trace ownership and recorded encumbrances before title opinions and insurance became more common."
  },
  {
    id: 159,
    question: "What is a cloud on title?",
    answer: "An unresolved claim, defect, or encumbrance that may impair ownership or transfer of title.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "easy",
    explanation: "Clouds on title include unresolved liens, recording errors, or competing claims that can interfere with a sale or financing."
  },
  {
    id: 160,
    question: "What is a quiet title action?",
    answer: "A court action brought to establish or clear title against adverse claims.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Quiet title litigation is used when ownership claims or defects need to be judicially resolved before the property can be conveyed cleanly."
  },
  {
    id: 161,
    question: "What does intestate mean in property transfer law?",
    answer: "Dying without a valid will.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "When a person dies intestate, state law determines how property passes rather than the person's will."
  },
  {
    id: 162,
    question: "What is probate?",
    answer: "The legal process of proving a will and administering a deceased person's estate.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Probate matters in real estate because title may need to pass through the estate before property can be sold or distributed."
  },
  {
    id: 163,
    question: "What is devise in real estate terminology?",
    answer: "A transfer of real property by will.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Students often pair devise with descent: devise is by will, while descent is by law when there is no valid will."
  },
  {
    id: 164,
    question: "What is descent in property transfer law?",
    answer: "The transfer of real property to heirs when an owner dies intestate.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This is a classic exam distinction from devise, which occurs through a valid will."
  },
  {
    id: 165,
    question: "What is alienation in real estate?",
    answer: "The transfer of ownership or an interest in property from one person to another.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Alienation can be voluntary, such as by deed, or involuntary, such as through foreclosure, tax sale, or eminent domain."
  },
  {
    id: 166,
    question: "What is an involuntary alienation of property?",
    answer: "A transfer of property without the owner's consent, such as through foreclosure, tax sale, condemnation, or escheat.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This concept tests whether the student can distinguish ordinary voluntary conveyance from transfers imposed by law."
  },
  {
    id: 167,
    question: "What is a power of attorney in a real estate transaction?",
    answer: "A written authorization allowing one person to act on behalf of another in specified matters.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "Power-of-attorney questions are important because documents may be signed by an authorized representative rather than the principal personally."
  },
  {
    id: 168,
    question: "What is a comparative market analysis (CMA)?",
    answer: "An estimate of probable market value prepared by a real estate licensee using recent comparable market data.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "A CMA is not the same as a formal appraisal by a licensed or certified appraiser, though both rely on market analysis."
  },
  {
    id: 169,
    question: "What is the difference between a CMA and an appraisal?",
    answer: "A CMA is a broker or agent's market-based pricing estimate, while an appraisal is a formal opinion of value performed by a qualified appraiser.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Exam questions often test whether students understand the agent's pricing role versus the appraiser's valuation role."
  },
  {
    id: 170,
    question: "What is the assessed valuation ratio?",
    answer: "The percentage of market value used to determine assessed value for property tax purposes.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "If market value and the assessment ratio are known, assessed value can be calculated by multiplying the two."
  },
  {
    id: 171,
    question: "What is an ad valorem tax?",
    answer: "A tax based on the assessed value of property.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "Property taxes are the standard example of ad valorem taxation because the tax is tied to value rather than a flat fee."
  },
  {
    id: 172,
    question: "What is a tax sale in real estate?",
    answer: "A sale process used to collect unpaid property taxes through the sale of a tax lien, tax certificate, or sometimes the property itself, depending on the law.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "The key exam point is that failure to pay property taxes can lead to enforced collection and loss of property rights."
  },
  {
    id: 173,
    question: "What is the purpose of subdivision regulations?",
    answer: "To control how land is divided and developed so that lots, streets, drainage, utilities, and public improvements meet local standards.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Subdivision rules are a major land-use tool because they shape development layout and public infrastructure requirements."
  },
  {
    id: 174,
    question: "What is a buffer zone in land-use planning?",
    answer: "An area used to separate different land uses in order to reduce conflict, noise, traffic impact, or visual intrusion.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Buffers are common planning tools between uses such as residential and commercial property."
  },
  {
    id: 175,
    question: "What is a floor area ratio (FAR)?",
    answer: "A zoning measure comparing the total building floor area to the size of the lot.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "hard",
    explanation: "FAR is especially important in denser development settings because it limits how much building area can be placed on a site."
  },
  {
    id: 176,
    question: "What is a cooperative maintenance fee generally used to cover?",
    answer: "The shareholder's share of building operating costs, such as maintenance, staff, utilities, taxes, and underlying debt obligations where applicable.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Co-op ownership differs from condo ownership partly because carrying costs often reflect the corporation's building-wide obligations."
  },
  {
    id: 177,
    question: "What is a condominium common element?",
    answer: "A part of the condominium property owned in common by the unit owners, such as hallways, roofs, lobbies, or recreational areas.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "Condo buyers receive title to their units plus an undivided interest in common elements."
  },
  {
    id: 178,
    question: "What is a special assessment in a cooperative or condominium context?",
    answer: "An additional charge imposed on owners or shareholders to cover unexpected expenses or major capital projects.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "This differs from ordinary monthly charges because it is typically imposed to address extraordinary costs."
  },
  {
    id: 179,
    question: "What is an option contract in real estate?",
    answer: "A contract in which the optionor gives the optionee the right, but not the obligation, to buy or lease property within a stated time.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "The option binds the seller or landlord if validly granted, but the buyer or tenant is not required to exercise it."
  },
  {
    id: 180,
    question: "What is a right of first refusal in a general contract sense?",
    answer: "A right requiring the owner to offer a party the chance to match or meet an offer before selling or leasing to someone else.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This is broader than the condo-specific example already covered because it tests the contract concept itself rather than one ownership form."
  },
  {
    id: 181,
    question: "What is a net listing price in investment analysis?",
    answer: "The amount the seller expects to receive after deducting specified transaction costs or obligations from the sale price.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "In investment and brokerage settings, students must distinguish gross sale price from the seller's net proceeds."
  },
  {
    id: 182,
    question: "What is leverage in real estate investment?",
    answer: "The use of borrowed money to control a larger investment than could be purchased with cash alone.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Leverage can increase returns when the investment performs well, but it also increases risk because debt obligations remain fixed."
  },
  {
    id: 183,
    question: "What is cash flow in an income property?",
    answer: "The amount of money remaining after operating expenses and debt service are paid.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "Cash flow differs from NOI because NOI is calculated before debt service, while cash flow reflects actual remaining cash after financing costs."
  },
  {
    id: 184,
    question: "What is equity in real estate investment?",
    answer: "The owner's interest in property value after subtracting liens and other encumbrances from market value.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "As loan balances decrease or value increases, equity generally rises."
  },
  {
    id: 185,
    question: "What is adjusted basis in a real estate tax context?",
    answer: "The owner's tax basis after adding certain capital improvements and subtracting items such as allowable depreciation.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Adjusted basis matters because gain or loss on sale is measured against it rather than against the original purchase price alone."
  },
  {
    id: 186,
    question: "What is capital gain in a real estate sale?",
    answer: "The gain realized when property sells for more than its adjusted basis, subject to applicable tax rules.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "medium",
    explanation: "This is a core tax concept in real estate transactions because profit for tax purposes depends on basis, not just sale price."
  },
  {
    id: 187,
    question: "What is a mortgage loan originator generally involved in?",
    answer: "Taking a residential mortgage application or offering or negotiating residential mortgage loan terms for compensation.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "This concept helps students distinguish general real estate brokerage activity from regulated mortgage-origination functions."
  },
  {
    id: 188,
    question: "What is predatory lending?",
    answer: "Abusive or deceptive lending practices that take unfair advantage of borrowers through terms, costs, or tactics that are not in the borrower's interest.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Predatory lending appears in exam study because mortgage-related consumer protection is part of the broader real estate finance framework."
  },
  {
    id: 189,
    question: "What is coinsurance in property insurance?",
    answer: "A policy requirement that the insured carry coverage equal to a stated percentage of value in order to avoid reduced claim recovery.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "hard",
    explanation: "Coinsurance is tested because underinsuring property can leave an owner with less reimbursement than expected after a partial loss."
  },
  {
    id: 190,
    question: "What is liability insurance in a property ownership context?",
    answer: "Coverage designed to protect against claims for bodily injury or property damage for which the insured may be legally responsible.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "Property insurance protects the structure and related property interests, while liability insurance addresses claims brought by others."
  },
  {
    id: 191,
    question: "What is the role of a municipal building department in real estate practice?",
    answer: "To administer building-code enforcement, permits, inspections, and related occupancy approvals.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "easy",
    explanation: "This clarifies the difference between planning and zoning bodies, which address land-use decisions, and building departments, which handle code compliance."
  },
  {
    id: 192,
    question: "What is an official map in municipal planning?",
    answer: "A map adopted by a local government showing proposed or existing public features such as streets, parks, and public areas for planning purposes.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "hard",
    explanation: "The syllabus references planning tools like the official map because they influence future development and public improvements."
  },
  {
    id: 193,
    question: "What is a master or comprehensive plan in land-use planning?",
    answer: "A long-range policy guide for growth, land use, transportation, public facilities, and community development.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "medium",
    explanation: "Planning boards and local governments use comprehensive plans to guide zoning, subdivision review, and capital improvements."
  },
  {
    id: 194,
    question: "What is the purpose of a safety protocol for showings and open houses?",
    answer: "To reduce risk by verifying appointments, controlling access, maintaining communication, and staying aware of personal safety conditions.",
    category: "NY License Law and Professional Practice",
    difficulty: "easy",
    explanation: "This expands the safety unit beyond general awareness by focusing on practical procedures used in field work."
  },
  {
    id: 195,
    question: "What is a deed covenant?",
    answer: "A promise contained in a deed regarding title, authority to convey, or freedom from certain encumbrances.",
    category: "NY License Law and Professional Practice",
    difficulty: "medium",
    explanation: "Deed covenants are tested because different deed forms provide different levels of protection and title assurance."
  },
  {
    id: 196,
    question: "What is a habendum clause in a deed?",
    answer: "The clause that identifies the type and extent of ownership interest being conveyed to the grantee.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "This is a classic deed-structure term. Students often remember it as the clause that describes what interest the grantee will 'have and hold.'"
  },
  {
    id: 197,
    question: "What is a legal life estate pur autre vie?",
    answer: "A life estate measured by the life of someone other than the life tenant.",
    category: "NY Property, Ownership, and Land Use",
    difficulty: "hard",
    explanation: "This is a more advanced estates-and-interests concept that appears in licensing study as a variation on the ordinary life estate."
  },
  {
    id: 198,
    question: "What is a percentage of vacancy used for in property analysis?",
    answer: "To estimate expected income loss from units or space not being occupied and producing rent.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "medium",
    explanation: "Vacancy allowance is important because projected gross income is not the same as effective income actually expected to be collected."
  },
  {
    id: 199,
    question: "What is effective gross income in an income-producing property?",
    answer: "The income remaining after subtracting vacancy and collection losses from potential gross income and adding any other operating income.",
    category: "NY Brokerage Operations and Transactions",
    difficulty: "hard",
    explanation: "This concept bridges property management and valuation because effective gross income is a step used in analyzing operating performance."
  },
  {
    id: 200,
    question: "What is a simple way to distinguish the three main valuation approaches on the exam?",
    answer: "Sales comparison looks at comparable sales, cost looks at replacement or reproduction cost minus depreciation plus land, and income looks at the property's earning power.",
    category: "NY Finance, Valuation, and Math",
    difficulty: "easy",
    explanation: "This synthesis card reinforces the purpose of each approach and helps students choose the right method in scenario-based questions."
  },
  {
    id: 201,
    question: "What is real property?",
    answer: "Land, anything permanently attached to the land, and the bundle of legal rights that comes with ownership.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Real property includes the physical land, improvements such as buildings, and legal interests like possession, control, enjoyment, exclusion, and disposition."
  },
  {
    id: 202,
    question: "What is the difference between real property and personal property?",
    answer: "Real property is immovable land and attached improvements, while personal property is movable and not permanently attached.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "The exam frequently tests whether an item is a fixture that became part of the real estate or remains personal property that can be removed."
  },
  {
    id: 203,
    question: "What is a fixture in real estate?",
    answer: "An item that was once personal property but became real property because it is attached or adapted to the land or building.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Fixture questions are commonly analyzed with tests such as method of attachment, adaptation, intent of the parties, relationship of the parties, and agreement."
  },
  {
    id: 204,
    question: "What does the bundle of rights include?",
    answer: "The rights of possession, control, enjoyment, exclusion, and disposition.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "These rights describe the legal benefits of ownership, though they can be limited by government powers, private restrictions, or liens."
  },
  {
    id: 205,
    question: "What is a fee simple estate?",
    answer: "The highest form of private ownership, with the greatest possible bundle of rights and potentially infinite duration.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Fee simple may be absolute or defeasible, but in either case it represents freehold ownership rather than a temporary leasehold interest."
  },
  {
    id: 206,
    question: "What is a life estate?",
    answer: "A freehold estate that lasts for the life of a named person and ends at that person's death.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "A life estate is not inheritable. When it ends, title passes to the remainderman or reverts to the original grantor, depending on how it was created."
  },
  {
    id: 207,
    question: "What is the difference between a freehold estate and a leasehold estate?",
    answer: "A freehold estate involves ownership for an uncertain duration, while a leasehold estate gives a tenant the right to possess property for a limited time.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Freehold estates include fee simple and life estates. Leasehold estates are nonfreehold interests such as estate for years, periodic tenancy, and tenancy at will."
  },
  {
    id: 208,
    question: "What is tenancy in common?",
    answer: "A form of co-ownership in which two or more people hold undivided interests that may be unequal and are inheritable.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Each tenant in common has the right to use the whole property, but there is no right of survivorship unless state law or the deed provides otherwise."
  },
  {
    id: 209,
    question: "What is joint tenancy?",
    answer: "A form of co-ownership in which co-owners hold equal undivided interests with a right of survivorship.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Joint tenancy typically requires the four unities of time, title, interest, and possession. When one owner dies, that interest passes to the surviving joint tenants."
  },
  {
    id: 210,
    question: "What is tenancy by the entirety?",
    answer: "A special form of ownership available only to married couples in many states, featuring survivorship and protection from the separate debts of one spouse in some jurisdictions.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This estate is tested as a marital ownership form. The exact creditor protections depend on state law, but nationally it is distinguished from ordinary joint tenancy."
  },
  {
    id: 211,
    question: "What is an easement appurtenant?",
    answer: "An easement that benefits one parcel of land and runs with that land, usually involving a dominant tenement and a servient tenement.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Because it attaches to the land rather than a specific person, an easement appurtenant generally transfers automatically when the benefited parcel is sold."
  },
  {
    id: 212,
    question: "What is an easement in gross?",
    answer: "An easement that benefits a person or company rather than a neighboring parcel of land.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Utility easements are a common example. Unlike an easement appurtenant, there is no dominant tenement because the benefit is personal or commercial."
  },
  {
    id: 213,
    question: "What is an encroachment?",
    answer: "An unauthorized physical intrusion of one person's improvement onto another person's land.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Examples include a fence, driveway, or structure crossing a boundary line. Encroachments are often discovered by a survey and can create title issues."
  },
  {
    id: 214,
    question: "What is a lien?",
    answer: "A charge against property that secures payment of a debt or performance of an obligation.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Liens can be voluntary, such as a mortgage, or involuntary, such as a property tax lien or judgment lien."
  },
  {
    id: 215,
    question: "Which lien generally has highest priority: a property tax lien or a mortgage lien?",
    answer: "A property tax lien generally has highest priority.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Ad valorem tax liens are typically superior to previously recorded private liens, making lien priority a frequent exam concept."
  },
  {
    id: 216,
    question: "What are the basic government powers over real estate?",
    answer: "Taxation, eminent domain, police power, and escheat.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "A common exam memory aid is PETE: Police power, Eminent domain, Taxation, and Escheat."
  },
  {
    id: 217,
    question: "What is eminent domain?",
    answer: "The government's power to take private property for public use, with payment of just compensation.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "The taking itself is eminent domain; the legal process used to carry it out is condemnation."
  },
  {
    id: 218,
    question: "What is police power in real estate?",
    answer: "The government's authority to regulate land use in order to protect public health, safety, morals, and general welfare.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Zoning, building codes, environmental regulations, and subdivision rules are classic examples of police power."
  },
  {
    id: 219,
    question: "What is a metes-and-bounds legal description?",
    answer: "A description that identifies a parcel by starting at a point of beginning and tracing its boundaries by directions and distances.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This method is commonly used for irregularly shaped parcels and must return to the point of beginning to fully describe the property."
  },
  {
    id: 220,
    question: "What is the rectangular survey system used to describe?",
    answer: "Land in many states using principal meridians, base lines, townships, ranges, and sections.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Also called the government survey system, it generally applies to land divided into 6-mile-square townships, each containing 36 one-mile-square sections."
  },
  {
    id: 221,
    question: "What is an express agency relationship in real estate?",
    answer: "An agency relationship created by an oral or written agreement between the principal and the agent.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "Listing agreements and buyer representation agreements are common examples of express agency because the relationship is intentionally created."
  },
  {
    id: 222,
    question: "What is implied agency?",
    answer: "An agency relationship inferred from the actions or conduct of the parties rather than from an explicit agreement.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "This is risky because a licensee may create agency duties unintentionally through words or behavior even without a signed agreement."
  },
  {
    id: 223,
    question: "Which fiduciary duties does an agent owe a client?",
    answer: "Loyalty, obedience, disclosure, confidentiality, reasonable care, and accounting.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "These duties are heavily tested nationally because agency law is one of the most important exam categories."
  },
  {
    id: 224,
    question: "What is a customer in a real estate transaction?",
    answer: "A party who is not represented as a client but is still owed honest and fair dealing.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "A customer does not receive full fiduciary representation, but the licensee still must avoid fraud, misrepresentation, and concealment of material facts."
  },
  {
    id: 225,
    question: "What are the basic elements required for a valid contract?",
    answer: "Competent parties, lawful objective, offer and acceptance, and consideration.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "National exams often test whether a contract is valid, void, voidable, or unenforceable based on missing elements."
  },
  {
    id: 226,
    question: "What is consideration in a real estate contract?",
    answer: "Something of value exchanged by the parties, such as a promise, money, or performance.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "Consideration does not have to be earnest money. Mutual promises alone can be sufficient consideration."
  },
  {
    id: 227,
    question: "What does the Statute of Frauds generally require for contracts involving the sale of real estate?",
    answer: "They must be in writing and signed by the party to be charged in order to be enforceable.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "This rule is central in real estate because agreements affecting title or long-term interests in land usually must be written."
  },
  {
    id: 228,
    question: "What is earnest money?",
    answer: "A buyer's good-faith deposit showing serious intent to complete the purchase.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "Earnest money helps support the offer and is usually credited at closing if the transaction is completed."
  },
  {
    id: 229,
    question: "What is a contingency in a real estate contract?",
    answer: "A condition that must be met for the contract to remain binding or proceed to closing.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Financing, appraisal, and inspection contingencies are common examples that protect parties from specified risks."
  },
  {
    id: 230,
    question: "What is a promissory note?",
    answer: "A borrower's written promise to repay a debt according to specified terms.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "The note creates the debt, while the mortgage or deed of trust secures that debt with the property."
  },
  {
    id: 231,
    question: "What is the difference between a mortgage and a promissory note?",
    answer: "The promissory note is the promise to repay, while the mortgage is the security instrument that pledges the property as collateral.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Students often confuse the debt instrument with the security instrument. The note and mortgage serve different legal functions."
  },
  {
    id: 232,
    question: "What is loan-to-value ratio (LTV)?",
    answer: "The loan amount divided by the value or purchase price of the property, expressed as a percentage.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "LTV helps lenders measure risk because a higher LTV means the borrower has less equity invested."
  },
  {
    id: 233,
    question: "What is amortization?",
    answer: "The repayment of a loan over time through periodic installments of principal and interest.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "With full amortization, the loan balance is reduced to zero by the end of the loan term."
  },
  {
    id: 234,
    question: "What is private mortgage insurance (PMI)?",
    answer: "Insurance that protects the lender against borrower default, commonly required on certain high-LTV conventional loans.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "PMI protects the lender, not the borrower. It is often associated with loans where the down payment is less than 20 percent."
  },
  {
    id: 235,
    question: "What is the federal Fair Housing Act designed to prohibit?",
    answer: "Discrimination in housing-related activities based on protected characteristics.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "The national exam regularly tests fair housing because it applies broadly to real estate practice across states."
  },
  {
    id: 236,
    question: "What is steering in fair housing law?",
    answer: "Guiding buyers or renters toward or away from certain areas based on protected characteristics.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Steering is illegal because it limits housing choice based on discriminatory criteria."
  },
  {
    id: 237,
    question: "What is title insurance?",
    answer: "Insurance that protects against certain losses from defects in title that existed before the policy was issued.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Title insurance differs from hazard insurance because it covers ownership defects and encumbrance issues, not future property damage."
  },
  {
    id: 238,
    question: "What is depreciation in appraisal?",
    answer: "A loss in value from any cause, including physical deterioration, functional obsolescence, or external obsolescence.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "In appraisal, depreciation is broader than tax depreciation. It refers to any reduction in value."
  },
  {
    id: 239,
    question: "What is external obsolescence?",
    answer: "A loss in value caused by negative influences outside the property boundaries.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Nearby nuisances, adverse zoning changes, or neighborhood decline are common examples."
  },
  {
    id: 240,
    question: "What is a closing or settlement statement?",
    answer: "A document that itemizes the financial debits, credits, and amounts due from or to the parties at closing.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "This document shows how the final money figures in the transaction were calculated."
  },
  {
    id: 241,
    question: "What is prorating at closing?",
    answer: "Allocating expenses or income between buyer and seller according to the date of closing and each party's period of ownership or use.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Taxes, rents, interest, and association charges are common items that may be prorated."
  },
  {
    id: 242,
    question: "What is RESPA primarily designed to regulate?",
    answer: "Residential settlement practices, required disclosures, and the prohibition of certain kickbacks and referral fees in covered mortgage transactions.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "RESPA is a core national exam topic because it governs important parts of the closing process."
  },
  {
    id: 243,
    question: "What is TILA primarily designed to require?",
    answer: "Truthful disclosure of the cost of consumer credit so borrowers can compare loan terms.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "TILA focuses on credit cost disclosure, while RESPA focuses more on settlement practices and related disclosures."
  },
  {
    id: 244,
    question: "What is an FHA-insured loan?",
    answer: "A loan made by an approved lender and insured by the Federal Housing Administration against borrower default.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "The FHA does not usually lend the money directly. Instead, it insures approved loans that meet program standards."
  },
  {
    id: 245,
    question: "What is a VA-guaranteed loan?",
    answer: "A loan made by an approved lender and guaranteed by the Department of Veterans Affairs for eligible borrowers.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "Like FHA loans, VA loans are generally originated by lenders, while the federal government provides the guarantee rather than directly funding most loans."
  },
  {
    id: 246,
    question: "What is a conventional loan?",
    answer: "A loan that is not insured or guaranteed by a government agency such as FHA or VA.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "Conventional loans may be conforming or nonconforming depending on whether they meet secondary market standards."
  },
  {
    id: 247,
    question: "What is an adjustable-rate mortgage (ARM)?",
    answer: "A mortgage with an interest rate that can change over time based on the terms of the loan.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "ARMs are tested because payment amounts can change after the initial fixed-rate period, increasing borrower risk."
  },
  {
    id: 248,
    question: "What is the federal lead-based paint disclosure requirement generally associated with?",
    answer: "Many residential properties built before 1978.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "This is a major federal disclosure topic because older housing stock may contain lead-based paint hazards."
  },
  {
    id: 249,
    question: "Which protected classes are covered under the federal Fair Housing Act?",
    answer: "Race, color, religion, sex, national origin, familial status, and disability.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This list is heavily tested nationally. Some states add more protected classes, but these are the core federal categories."
  },
  {
    id: 250,
    question: "What is a general warranty deed?",
    answer: "A deed in which the grantor gives broad covenants of title and warrants against defects arising both before and during the grantor's ownership.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "This deed gives the grantee the greatest protection because the grantor warrants the title against a broad range of defects."
  },
  {
    id: 251,
    question: "What is a special warranty deed?",
    answer: "A deed in which the grantor warrants title only against defects arising during the grantor's period of ownership.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "The grantor does not make promises about defects that may have existed before the grantor acquired title."
  },
  {
    id: 252,
    question: "What is a quitclaim deed?",
    answer: "A deed that conveys whatever interest the grantor may have, if any, without warranties of title.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Quitclaim deeds are often used to clear clouds on title or transfer possible interests without guaranteeing ownership."
  },
  {
    id: 253,
    question: "What is actual notice in real estate?",
    answer: "Direct knowledge of a fact, claim, or condition affecting property or a transaction.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Actual notice differs from constructive notice, which is knowledge the law presumes because information is in the public record."
  },
  {
    id: 254,
    question: "What is a balloon payment?",
    answer: "A large lump-sum payment due at the end of a loan term after smaller regular payments have been made.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Balloon loans are risky for borrowers who may be unable to refinance or pay the final amount when due."
  },
  {
    id: 255,
    question: "What is assumed by a buyer who takes over an existing mortgage through assumption?",
    answer: "Responsibility for the mortgage debt, subject to lender approval and the terms of the transaction.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Assumption differs from taking title subject to a mortgage because assumption generally involves personal liability for the debt."
  },
  {
    id: 256,
    question: "What is dual agency?",
    answer: "An agency relationship in which one brokerage or agent represents both the buyer and the seller in the same transaction, subject to state law and required consent.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "Dual agency is heavily tested because it creates potential conflicts with undivided loyalty and full disclosure."
  },
  {
    id: 257,
    question: "What is a universal agent?",
    answer: "An agent authorized to act for a principal in a broad range of matters, often under a power of attorney.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "This contrasts with a special agent, such as a real estate broker, who is typically authorized for limited acts related to a specific transaction."
  },
  {
    id: 258,
    question: "What is a special agent in real estate?",
    answer: "An agent authorized to perform specific acts for a principal, usually related to a particular transaction.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "Real estate licensees are commonly treated as special agents because their authority is limited to tasks like finding a buyer or seller."
  },
  {
    id: 259,
    question: "If a property sells for $360,000 and the commission is 6%, what is the total commission?",
    answer: "$21,600.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Commission equals sale price multiplied by commission rate. Here, $360,000 x 0.06 = $21,600."
  },
  {
    id: 260,
    question: "If annual property taxes are $4,800, what is the monthly amount for tax escrow?",
    answer: "$400.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "To find the monthly escrow amount, divide the annual taxes by 12. Here, $4,800 / 12 = $400."
  },
  {
    id: 261,
    question: "If a lender loans $240,000 at 80% loan-to-value, what is the property's value or purchase price?",
    answer: "$300,000.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Value equals loan amount divided by LTV. Here, $240,000 / 0.80 = $300,000."
  },
  {
    id: 262,
    question: "What is the federal lead-based paint disclosure rule designed to require from sellers and landlords of many pre-1978 homes?",
    answer: "Disclosure of known lead-based paint hazards and delivery of the required federal information pamphlet.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "The national exam tests not only the 1978 cutoff but also the seller and landlord disclosure obligations tied to older housing."
  },
  {
    id: 263,
    question: "What is redlining?",
    answer: "An illegal practice of denying or restricting loans or insurance in certain areas based on discriminatory factors rather than legitimate underwriting standards.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Redlining is tested as a discriminatory housing and lending practice that limits equal access to housing opportunity."
  },
  {
    id: 264,
    question: "What is a void contract?",
    answer: "A contract that has no legal effect from the beginning because it lacks a required element or involves an illegal purpose.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "A void contract cannot be enforced by either party because the law treats it as if it never existed."
  },
  {
    id: 265,
    question: "What is a voidable contract?",
    answer: "A contract that is valid unless one of the parties with the legal right to do so chooses to rescind it.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Contracts involving a minor or a party under duress are common examples of potentially voidable agreements."
  },
  {
    id: 266,
    question: "What is specific performance?",
    answer: "A court remedy requiring a party to carry out the contract as agreed.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Because real estate is considered unique, specific performance is a common remedy in disputes involving sales contracts."
  },
  {
    id: 267,
    question: "What is recording in real estate?",
    answer: "The act of placing a document in the public record to give notice and help protect ownership or lien priority.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Recording does not usually create validity by itself, but it helps establish public notice and priority among competing claims."
  },
  {
    id: 268,
    question: "What is the purpose of a title search?",
    answer: "To examine public records for defects, liens, encumbrances, and ownership issues that may affect title.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "A title search helps identify problems before closing so they can be cleared, disclosed, or insured against where appropriate."
  },
  {
    id: 269,
    question: "What is a debit at closing?",
    answer: "An amount charged against a party on the settlement statement.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Debits increase the amount a party must pay or reduce the amount the party receives at closing."
  },
  {
    id: 270,
    question: "What is a credit at closing?",
    answer: "An amount entered in favor of a party on the settlement statement.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Credits reduce the amount a party must bring to closing or increase the amount the party will receive."
  },
  {
    id: 271,
    question: "What is the difference between prepaid items and accrued items at closing?",
    answer: "Prepaid items are paid in advance and usually credited back to the seller, while accrued items are owed at closing and usually charged to the seller.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "This is a standard proration concept. The key is identifying whether the item has already been paid or is still unpaid as of closing."
  },
  {
    id: 272,
    question: "What is a fixture by adaptation?",
    answer: "Personal property that becomes real property because it is specially adapted or custom-fitted to the property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Adaptation is one of the classic tests used to decide whether an item has become a fixture."
  },
  {
    id: 273,
    question: "What is trade fixture?",
    answer: "Personal property installed by a commercial tenant for business purposes that is generally removable before the lease ends.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Trade fixtures are an important exception to the usual rule that attached items become part of the real estate."
  },
  {
    id: 274,
    question: "What is a general lien?",
    answer: "A lien affecting all of a debtor's property, both real and personal, rather than one specific parcel.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Judgment liens are a common example of general liens, while a mortgage is usually a specific lien."
  },
  {
    id: 275,
    question: "What is a specific lien?",
    answer: "A lien that attaches to a particular piece of property rather than all property owned by the debtor.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "A mortgage or property tax lien on a specific parcel is a common example of a specific lien."
  },
  {
    id: 276,
    question: "What is escheat?",
    answer: "The government's power to take ownership of property when a person dies without heirs and without a valid will.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Escheat is one of the four classic government powers over real estate and is often remembered with the PETE acronym."
  },
  {
    id: 277,
    question: "What is condemnation in real estate?",
    answer: "The legal process used to take private property for public use under the power of eminent domain.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Students often confuse eminent domain with condemnation. Eminent domain is the power; condemnation is the process."
  },
  {
    id: 278,
    question: "What is zoning?",
    answer: "A police-power tool that regulates land use, building types, density, and other development limits within designated areas.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Zoning is one of the most frequently tested examples of police power because it directly controls how land may be used."
  },
  {
    id: 279,
    question: "What is a defeasible fee estate?",
    answer: "A fee estate that can be lost if a stated condition is violated or a specified event occurs.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "A defeasible fee is still a freehold estate, but it is subject to a condition that can limit the owner's continued interest."
  },
  {
    id: 280,
    question: "What is a reversion in real estate?",
    answer: "The interest that remains with a grantor after conveying a lesser estate, with possession returning when that lesser estate ends.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "For example, if a grantor gives someone a life estate but keeps the future interest, the property reverts when the life estate ends."
  },
  {
    id: 281,
    question: "What is a remainder interest?",
    answer: "A future interest that takes effect after the end of a prior estate, such as a life estate.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "A remainder goes to a third party designated to take title when the prior estate ends, rather than back to the grantor."
  },
  {
    id: 282,
    question: "What is tenancy at will?",
    answer: "A leasehold estate that continues only as long as both landlord and tenant agree.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "It has no definite ending date and may usually be terminated with proper notice as required by law."
  },
  {
    id: 283,
    question: "What is tenancy at sufferance?",
    answer: "A tenancy created when a tenant remains in possession after the lawful lease term has ended without the landlord's consent.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "This is commonly called a holdover tenancy. The landlord may choose to evict or, in some situations, treat the holdover as a new tenancy."
  },
  {
    id: 284,
    question: "What is a lot and block legal description?",
    answer: "A legal description that identifies property by lot number, block number, subdivision name, and recorded plat reference.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Also called the recorded plat method, it is commonly used in developed subdivisions."
  },
  {
    id: 285,
    question: "How many sections are in a township under the rectangular survey system?",
    answer: "36 sections.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "A township is generally a 6-mile-by-6-mile square containing 36 one-mile-square sections."
  },
  {
    id: 286,
    question: "How many acres are in one section of land under the rectangular survey system?",
    answer: "640 acres.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "One section is one square mile, and one square mile contains 640 acres."
  },
  {
    id: 287,
    question: "What is stigmatized property?",
    answer: "Property that may be viewed negatively for reasons unrelated to its physical condition or title, depending on state law and market perception.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Examples can include prior events or public perceptions. Disclosure duties vary by jurisdiction, which is why the national concept is tested carefully."
  },
  {
    id: 288,
    question: "What is mold as a real estate disclosure issue?",
    answer: "A potential environmental and health concern arising from moisture conditions that may materially affect a property's condition or habitability.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Mold questions often focus on whether the condition is material and whether the licensee knows of it."
  },
  {
    id: 289,
    question: "What is reasonable accommodation under fair housing law?",
    answer: "A change in rules, policies, practices, or services that may be necessary to give a person with a disability equal housing opportunity.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This differs from a reasonable modification, which is a physical change to the property itself."
  },
  {
    id: 290,
    question: "What is reasonable modification under fair housing law?",
    answer: "A physical change to a dwelling or common area that may be necessary for a person with a disability to fully use and enjoy the property.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "Students often confuse modification with accommodation. Modification changes the premises, while accommodation changes rules or services."
  },
  {
    id: 291,
    question: "What is the purpose of fair housing enforcement remedies?",
    answer: "To provide relief when unlawful housing discrimination is proven and to deter future discriminatory conduct.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Fair housing law is tested not just as a list of prohibited conduct, but also as a system with enforcement and remedies."
  },
  {
    id: 292,
    question: "What is the Equal Credit Opportunity Act (ECOA) designed to prohibit?",
    answer: "Discrimination in credit decisions on prohibited bases.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Although it is a credit law rather than a housing sale law, ECOA appears in national real estate exam study because financing discrimination affects housing access."
  },
  {
    id: 293,
    question: "If a broker earns a 3% side of the commission on a $425,000 sale, how much is that side?",
    answer: "$12,750.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply $425,000 by 0.03 to get $12,750."
  },
  {
    id: 294,
    question: "If a property has a gross monthly rent of $2,400, what is the annual gross rent?",
    answer: "$28,800.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply the monthly rent by 12. Here, $2,400 x 12 = $28,800."
  },
  {
    id: 295,
    question: "What is the difference between an employee and an independent contractor in a brokerage context?",
    answer: "An employee is subject to greater control over how work is performed, while an independent contractor generally controls the manner and method of work subject to the contract and law.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "This distinction matters for supervision, compensation, and tax treatment, and it appears in national exam prep as a brokerage practice concept."
  },
  {
    id: 296,
    question: "What are the four unities traditionally required for joint tenancy?",
    answer: "Time, title, interest, and possession.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "These four unities help distinguish joint tenancy from tenancy in common and support the right of survivorship."
  },
  {
    id: 297,
    question: "What happens to a joint tenant's interest at death?",
    answer: "It passes automatically to the surviving joint tenant or joint tenants by right of survivorship.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This transfer occurs outside of probate because the survivorship feature controls the passage of the interest."
  },
  {
    id: 298,
    question: "What is partition in co-ownership?",
    answer: "A legal action to divide property among co-owners or, if division is impractical, force its sale and divide the proceeds.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Partition is important because co-owners do not have to remain co-owners forever if they cannot agree."
  },
  {
    id: 299,
    question: "What is an easement by necessity?",
    answer: "An easement implied by law when property would otherwise be landlocked and access is reasonably necessary.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This type of easement is created to avoid rendering land unusable due to lack of access."
  },
  {
    id: 300,
    question: "What is an easement by prescription?",
    answer: "An easement acquired through open, notorious, continuous, and adverse use for the statutory period.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "It is similar in concept to adverse possession, except it creates a right to use rather than ownership of the land."
  },
  {
    id: 301,
    question: "What is a restrictive covenant?",
    answer: "A private restriction that limits how property may be used.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Restrictive covenants are private controls on land use and differ from public controls such as zoning."
  },
  {
    id: 302,
    question: "What is subordination in lien priority?",
    answer: "An agreement by which a lienholder voluntarily allows another lien to take priority over its own lien.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Subordination changes the normal order of priority and is important in construction and refinancing contexts."
  },
  {
    id: 303,
    question: "What is net operating income (NOI)?",
    answer: "Income remaining after operating expenses are subtracted from gross income, but before debt service and income taxes.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "NOI is central to income-property analysis because it isolates the property's operating performance from financing choices."
  },
  {
    id: 304,
    question: "What is capitalization rate?",
    answer: "A rate used to convert income into value, commonly found by dividing net operating income by value or price.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "The cap rate helps connect a property's income performance to its market value."
  },
  {
    id: 305,
    question: "What is appreciation in real estate?",
    answer: "An increase in property value over time due to market forces, improvements, or other favorable factors.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Appreciation is the opposite of a decline in value and is distinct from tax depreciation, which is an accounting concept."
  },
  {
    id: 306,
    question: "What is a prepaid expense at closing?",
    answer: "An expense that has already been paid in advance and is usually credited back to the payer for the unused portion after closing.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Examples may include prepaid property taxes or insurance, depending on the timing of the closing and billing cycle."
  },
  {
    id: 307,
    question: "What is an accrued expense at closing?",
    answer: "An expense that has been incurred but not yet paid as of closing and is usually charged to the party who benefited from it before closing.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Accrued items commonly include unpaid property taxes or interest earned up to the closing date."
  },
  {
    id: 308,
    question: "What is the purpose of the Americans with Disabilities Act (ADA) in a real estate context?",
    answer: "To require accessibility standards in covered public accommodations and commercial facilities, rather than to govern private residential ownership generally.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Students often confuse the ADA with fair housing law. The ADA primarily addresses accessibility in covered public and commercial settings."
  },
  {
    id: 309,
    question: "What is an optionor in an option contract?",
    answer: "The party who grants the option and is bound to keep the offer open for the option period.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "In a sale option, the seller is often the optionor because the seller grants the buyer the right to purchase."
  },
  {
    id: 310,
    question: "What is an optionee in an option contract?",
    answer: "The party who receives the right to exercise the option within the specified period.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "The optionee has the right, but not the obligation, to exercise the option according to its terms."
  },
  {
    id: 311,
    question: "If a property's annual NOI is $36,000 and the capitalization rate is 9%, what is the indicated value?",
    answer: "$400,000.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Value equals NOI divided by capitalization rate. Here, $36,000 / 0.09 = $400,000."
  },
  {
    id: 312,
    question: "What is adverse possession?",
    answer: "A method of acquiring title to property by open, notorious, continuous, exclusive, and adverse possession for the statutory period.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "Adverse possession transfers ownership, unlike a prescriptive easement, which creates only a right to use."
  },
  {
    id: 313,
    question: "What is a probate sale in real estate?",
    answer: "A sale of property from a deceased person's estate through the probate process.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Probate sales are part of title transfer by operation of law or court-supervised process rather than ordinary voluntary transfer alone."
  },
  {
    id: 314,
    question: "What is intestate succession?",
    answer: "The transfer of property according to state law when a person dies without a valid will.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "This is distinct from transfer by devise, which occurs under a will."
  },
  {
    id: 315,
    question: "What is a nonconforming use?",
    answer: "A lawful existing use that no longer conforms to current zoning but may continue under applicable rules.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Nonconforming uses are tested because they illustrate how zoning changes can affect existing property rights."
  },
  {
    id: 316,
    question: "What is a variance in zoning?",
    answer: "Permission to deviate from the strict terms of a zoning ordinance when legal requirements for relief are met.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Variances are a classic zoning topic because they are exceptions granted without changing the ordinance itself."
  },
  {
    id: 317,
    question: "What is a building code?",
    answer: "A regulation establishing standards for construction, safety, materials, and building systems.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Building codes are another major example of police power because they protect public health and safety."
  },
  {
    id: 318,
    question: "What is a designated agency arrangement generally intended to do?",
    answer: "Allow a brokerage to assign one licensee to represent the buyer and another to represent the seller, subject to state law and required disclosures or consent.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "Designated agency is tested because it is often confused with full independent representation, even though the brokerage still has overall agency implications."
  },
  {
    id: 319,
    question: "What is ostensible or apparent agency?",
    answer: "An agency relationship that appears to exist because of the principal's or agent's conduct, even if no actual authority was intended.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "This concept matters because liability can arise from how the relationship appears to third parties, not just from written agreements."
  },
  {
    id: 320,
    question: "What is rescission in contract law?",
    answer: "The cancellation of a contract with the goal of restoring the parties to their positions before the contract.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Rescission is a common remedy when a contract is voidable, induced by misrepresentation, or otherwise legally defective."
  },
  {
    id: 321,
    question: "What is novation in a contract context?",
    answer: "The substitution of a new contract or new party for an old one, with the consent of all parties involved.",
    category: "National Contracts",
    difficulty: "hard",
    explanation: "Novation is more than amendment; it replaces an existing obligation with a new one."
  },
  {
    id: 322,
    question: "What is a reasonable person standard in disclosure questions?",
    answer: "A standard asking whether a typical prudent person would consider the fact important in deciding how to act.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This standard helps determine whether a fact is material and therefore likely subject to disclosure."
  },
  {
    id: 323,
    question: "What is a latent defect?",
    answer: "A hidden defect that is not readily observable by ordinary inspection.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Latent defects are commonly contrasted with patent defects, which are visible or readily discoverable."
  },
  {
    id: 324,
    question: "What is steering distinguished from if an agent simply provides objective information on properties that meet a buyer's stated criteria?",
    answer: "Steering is illegal guidance based on protected characteristics, while providing objective property information based on lawful client criteria is permissible.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This distinction is tested because agents must serve clients without channeling them based on discriminatory assumptions."
  },
  {
    id: 325,
    question: "What is transfer tax or documentary tax at closing?",
    answer: "A tax imposed on certain real estate conveyance documents or transfers, depending on the jurisdiction.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Transfer-related taxes are a common closing-cost concept, though the party responsible varies by state and local law."
  },
  {
    id: 326,
    question: "If a buyer places 15% down on a $320,000 purchase, how much is the down payment?",
    answer: "$48,000.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply $320,000 by 0.15 to get $48,000."
  },
  {
    id: 327,
    question: "What is riparian right?",
    answer: "A water right held by an owner whose land borders a flowing body of water such as a river or stream.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Riparian rights are commonly tested alongside littoral rights, which involve water bordering lakes, seas, or oceans."
  },
  {
    id: 328,
    question: "What is a littoral right?",
    answer: "A water right held by an owner whose land borders a nonflowing body of water such as a lake, sea, or ocean.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "National exams often compare littoral and riparian rights as different forms of water-related property rights."
  },
  {
    id: 329,
    question: "What is accretion?",
    answer: "The gradual addition of land by the deposit of soil through natural water action.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Accretion can increase a parcel's size over time, while erosion is the gradual loss of land."
  },
  {
    id: 330,
    question: "What is avulsion?",
    answer: "A sudden and noticeable loss or addition of land caused by water action.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "Avulsion differs from accretion because it is sudden rather than gradual."
  },
  {
    id: 331,
    question: "What is erosion in real estate?",
    answer: "The gradual loss of land by natural causes such as wind or flowing water.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Erosion is the opposite of accretion and is frequently tested in water-rights questions."
  },
  {
    id: 332,
    question: "What is an easement terminated by abandonment?",
    answer: "An easement that ends when the holder clearly demonstrates intent to give up the easement and stops using it.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Mere nonuse is usually not enough by itself; abandonment generally requires clear intent plus conduct."
  },
  {
    id: 333,
    question: "What is an easement terminated by merger?",
    answer: "An easement that ends when the dominant and servient estates come under common ownership.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Once one person owns both parcels, there is no need for one parcel to have an easement over the other."
  },
  {
    id: 334,
    question: "What is an easement terminated by release?",
    answer: "An easement that ends when the easement holder formally gives up the right, usually in writing.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "A release is one common way to terminate an easement when the holder no longer needs or wants it."
  },
  {
    id: 335,
    question: "What is a superior lien?",
    answer: "A lien that has priority over other liens and is paid first from foreclosure or sale proceeds.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Priority determines the order in which claims are satisfied when the property is sold."
  },
  {
    id: 336,
    question: "What is a junior lien?",
    answer: "A lien that has lower priority than a superior lien and is paid only after senior liens are satisfied.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Junior liens carry more risk because they may receive little or nothing if sale proceeds are insufficient."
  },
  {
    id: 337,
    question: "What generally ends a periodic tenancy?",
    answer: "Proper notice given as required by law or the lease terms.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "A periodic tenancy renews automatically until one party properly terminates it."
  },
  {
    id: 338,
    question: "What is a sandwich lease?",
    answer: "A lease arrangement in which the tenant subleases the property to another tenant while remaining liable to the original landlord.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "The intermediate tenant is both a tenant and a landlord in the chain of leasing."
  },
  {
    id: 339,
    question: "What is a subsection of land under the rectangular survey system if a section is divided into quarters and then one quarter is divided again into quarters?",
    answer: "A 40-acre tract.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "A section is 640 acres. One quarter section is 160 acres, and one quarter of that quarter is 40 acres."
  },
  {
    id: 340,
    question: "What direction does a range indicate in the rectangular survey system?",
    answer: "The east-west location of a township relative to a principal meridian.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Township indicates north-south position relative to a base line, while range indicates east-west position relative to a principal meridian."
  },
  {
    id: 341,
    question: "What direction does a township line indicate in the rectangular survey system?",
    answer: "The north-south location of a township relative to a base line.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This is a standard rectangular-survey distinction tested with township and range descriptions."
  },
  {
    id: 342,
    question: "If a lot measures 100 feet by 150 feet, how many square feet does it contain?",
    answer: "15,000 square feet.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply length by width. Here, 100 x 150 = 15,000 square feet."
  },
  {
    id: 343,
    question: "If a property contains 43,560 square feet, how many acres is it?",
    answer: "1 acre.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "One acre equals 43,560 square feet, which is a foundational national exam conversion."
  },
  {
    id: 344,
    question: "If a buyer obtains an 85% LTV loan on a $500,000 purchase, how much is the down payment?",
    answer: "$75,000.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "An 85% LTV loan means the loan is $425,000. The down payment is the remaining 15%, or $75,000."
  },
  {
    id: 345,
    question: "If a property's annual gross rent is $30,000 and its sale price is $300,000, what is the gross rent multiplier?",
    answer: "10.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "GRM equals sale price divided by annual gross rent. Here, $300,000 / $30,000 = 10."
  },
  {
    id: 346,
    question: "What is a fee simple absolute estate?",
    answer: "The most complete form of private ownership, with the greatest bundle of rights and no condition limiting duration.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This is the standard ownership estate most buyers think of when purchasing property in fee simple."
  },
  {
    id: 347,
    question: "What is a fee simple determinable estate?",
    answer: "A defeasible fee estate that automatically ends when a stated condition is violated or a specified event occurs.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This differs from a fee simple subject to condition subsequent because termination is automatic rather than requiring action by the grantor."
  },
  {
    id: 348,
    question: "What is a fee simple subject to condition subsequent?",
    answer: "A defeasible fee estate that may be terminated if a stated condition is violated, but it does not end automatically.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "The grantor must usually take action to reclaim the estate after the condition is breached."
  },
  {
    id: 349,
    question: "What is community property?",
    answer: "A form of marital property ownership recognized in some states under which most property acquired during marriage is jointly owned by both spouses.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Community property is distinct from tenancy by the entirety and does not apply in every state."
  },
  {
    id: 350,
    question: "What does undivided interest mean in co-ownership?",
    answer: "Each co-owner has a right to use and possess the whole property, not just a physically separated portion.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "An undivided interest means ownership shares are fractional interests in the entire property rather than ownership of separate rooms or sections."
  },
  {
    id: 351,
    question: "What is the difference between title and possession in co-ownership questions?",
    answer: "Title refers to legal ownership rights, while possession refers to the right to occupy or control the property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "The exam often tests whether a person can have possession without full title or title without exclusive possession."
  },
  {
    id: 352,
    question: "What is ratification in agency law?",
    answer: "The principal's approval of an act performed on the principal's behalf by someone who lacked authority at the time of the act.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "Ratification can bind the principal to the act if the principal later accepts it with knowledge of the material facts."
  },
  {
    id: 353,
    question: "What is agency by estoppel?",
    answer: "A situation in which a principal may be prevented from denying an agency relationship because the principal's conduct caused a third party to reasonably rely on its existence.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "This concept overlaps with apparent agency and focuses on protecting third parties who were misled by appearances."
  },
  {
    id: 354,
    question: "When does agency terminate by operation of law?",
    answer: "Agency may terminate automatically because of events such as death, incapacity, destruction of the property, or fulfillment of the agency purpose.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "Termination by operation of law does not depend on one party choosing to end the relationship."
  },
  {
    id: 355,
    question: "What is negligent misrepresentation in real estate?",
    answer: "A false statement made carelessly, without reasonable grounds for believing it to be true, that causes another person to rely on it.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Negligent misrepresentation differs from fraud because it does not require intent to deceive."
  },
  {
    id: 356,
    question: "What is a material latent defect?",
    answer: "A hidden condition known to the seller or licensee that could significantly affect value, safety, or desirability.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This combines two common exam ideas: the defect is hidden, and it is material enough that a reasonable person would care about it."
  },
  {
    id: 357,
    question: "What is the settlement date in a real estate transaction?",
    answer: "The date on which the parties complete the closing and the financial adjustments are finalized.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "This is the date used for many proration calculations and final transfer activities."
  },
  {
    id: 358,
    question: "What is a closing cost?",
    answer: "An expense associated with completing a real estate transaction in addition to the purchase price.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Examples include loan fees, title charges, recording fees, transfer taxes, and prepaid items."
  },
  {
    id: 359,
    question: "What is a recording fee at closing?",
    answer: "A charge for placing documents such as deeds or mortgages into the public record.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Recording fees are different from transfer taxes because they are administrative charges for recording documents."
  },
  {
    id: 360,
    question: "What is a special assessment?",
    answer: "A charge against property to pay for a public improvement that specially benefits that property.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Unlike a general property tax, a special assessment is tied to a particular improvement such as paving or sewer installation."
  },
  {
    id: 361,
    question: "What is a subdivision regulation?",
    answer: "A police-power control governing how land may be divided and improved, including streets, utilities, drainage, and lot standards.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Subdivision regulation is a common exam topic because it affects land development before lots are sold."
  },
  {
    id: 362,
    question: "What is a metes-and-bounds point of beginning?",
    answer: "The identifiable starting point from which the parcel's boundary lines are traced in a metes-and-bounds description.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "A valid metes-and-bounds description should return to the point of beginning to fully enclose the parcel."
  },
  {
    id: 363,
    question: "If a buyer pays $18 per square foot for a 2,500-square-foot property, what is the total price?",
    answer: "$45,000.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply the price per square foot by the number of square feet. Here, 2,500 x $18 = $45,000."
  },
  {
    id: 364,
    question: "What is a lien waiver?",
    answer: "A document in which a contractor, subcontractor, or supplier gives up the right to file a mechanic's lien for work or materials covered by the waiver.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Lien waivers are commonly used at closing or during construction to reduce the risk of later mechanic's lien claims."
  },
  {
    id: 365,
    question: "What is foreclosure?",
    answer: "The legal process used to enforce a mortgage or other lien against property when the borrower defaults.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Foreclosure allows the property to be sold so the debt can be satisfied from the sale proceeds according to lien priority."
  },
  {
    id: 366,
    question: "What is a deficiency judgment?",
    answer: "A court judgment against a borrower for the unpaid debt balance remaining after foreclosure sale proceeds are applied.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "If the foreclosure sale does not generate enough money to satisfy the debt, the lender may seek a deficiency judgment where allowed by law."
  },
  {
    id: 367,
    question: "What is a novation in mortgage financing?",
    answer: "The substitution of a new obligation or new party for an existing one, with consent of all parties, releasing the original obligation.",
    category: "National Financing",
    difficulty: "hard",
    explanation: "This is distinct from a simple assignment or amendment because the prior obligation is replaced rather than merely modified."
  },
  {
    id: 368,
    question: "What is a straight note?",
    answer: "A note under which interest is paid periodically and the principal is paid in one lump sum at maturity.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "A straight note differs from a fully amortized loan because the principal is not gradually reduced through each periodic payment."
  },
  {
    id: 369,
    question: "What is hypothecation?",
    answer: "The pledging of property as security for a debt without giving up possession of the property.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Mortgage financing commonly involves hypothecation because the borrower keeps possession while using the property as collateral."
  },
  {
    id: 370,
    question: "What is a release clause in a mortgage?",
    answer: "A clause allowing specific parcels or lots to be released from a blanket mortgage lien when stated conditions are met.",
    category: "National Financing",
    difficulty: "hard",
    explanation: "This clause is important in development financing because individual parcels may need to be sold free of the blanket lien."
  },
  {
    id: 371,
    question: "What is a blanket mortgage?",
    answer: "A mortgage that covers more than one parcel of real estate.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Blanket mortgages are common in subdivision and development contexts because one loan may secure multiple lots or parcels."
  },
  {
    id: 372,
    question: "What is an amendment to a contract?",
    answer: "A mutually agreed change to one or more terms of an existing contract.",
    category: "National Contracts",
    difficulty: "easy",
    explanation: "An amendment modifies the original agreement, while a novation replaces it with a new obligation or party."
  },
  {
    id: 373,
    question: "What is assignment of a contract?",
    answer: "The transfer of one party's contractual rights to another person.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Assignment generally transfers rights, while delegation relates to transferring duties."
  },
  {
    id: 374,
    question: "What is delegation in contract law?",
    answer: "The transfer of one party's contractual duties to another person.",
    category: "National Contracts",
    difficulty: "hard",
    explanation: "Delegating performance does not always release the original party from liability unless the other parties agree to a novation."
  },
  {
    id: 375,
    question: "What is a probate court's general role in property transfer?",
    answer: "To supervise the administration of a deceased person's estate, including property distribution and related legal matters.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Probate court involvement is important when title passes through an estate rather than by survivorship or direct lifetime transfer."
  },
  {
    id: 376,
    question: "What is a building permit generally required for?",
    answer: "Construction, alteration, or improvement work that must comply with building and safety codes.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "Permits are a standard police-power tool used to enforce construction standards before and during work."
  },
  {
    id: 377,
    question: "What is the Interstate Land Sales Full Disclosure Act generally designed to regulate?",
    answer: "Certain interstate sales of subdivided land through disclosure and anti-fraud requirements.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This federal law appears in national exam prep because it protects buyers of certain subdivided land sold across state lines."
  },
  {
    id: 378,
    question: "What is familial status under the federal Fair Housing Act?",
    answer: "Protection for households that include one or more individuals under 18 living with a parent, legal custodian, or designee, as well as pregnant persons and those securing custody of a child.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This protected class is commonly tested because it is broader than simply 'having children in the home today.'"
  },
  {
    id: 379,
    question: "If a seller owns property for 9 months of a tax year and annual taxes are $6,000, what is the seller's share before proration adjustments?",
    answer: "$4,500.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Nine months is 9/12 of the year. Multiply $6,000 by 9/12 to get $4,500."
  },
  {
    id: 380,
    question: "If a property is sold for $525,000 with a 5% commission split evenly between two brokerages, how much does each brokerage receive before internal splits?",
    answer: "$13,125.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "First find total commission: $525,000 x 0.05 = $26,250. Then divide by 2 to get $13,125 for each brokerage."
  },
  {
    id: 381,
    question: "What is a tenancy in common owner's right regarding transfer of that owner's interest?",
    answer: "A tenant in common may usually sell, convey, mortgage, or devise that owner's individual interest without consent of the other co-owners.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This is a key distinction from some other ownership arrangements because a tenancy in common interest is separately transferable and inheritable."
  },
  {
    id: 382,
    question: "What is the right of survivorship in joint tenancy intended to do?",
    answer: "Pass a deceased joint tenant's interest automatically to the surviving joint tenant or joint tenants.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This avoids probate for the deceased joint tenant's interest and is the defining feature that distinguishes joint tenancy from tenancy in common."
  },
  {
    id: 383,
    question: "What is a severance of joint tenancy?",
    answer: "An act that breaks one or more of the required unities, converting the affected interest into a tenancy in common in many jurisdictions.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "Because joint tenancy depends on the unities and survivorship, transferring one tenant's interest can sever the joint tenancy as to that share."
  },
  {
    id: 384,
    question: "What is annexation in fixture analysis?",
    answer: "The manner and degree of attachment of an item to the land or building.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Annexation is one of the classic tests used to determine whether personal property has become a fixture."
  },
  {
    id: 385,
    question: "What is emblements in property law?",
    answer: "Annual crops produced by cultivation that are generally treated as personal property.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "Emblements are an exception to the general rule that things attached to land are part of the real estate."
  },
  {
    id: 386,
    question: "What is a support easement?",
    answer: "An easement that gives one property the right to receive structural support from adjoining land or buildings.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Support rights may matter in dense development or where adjoining structures depend on one another physically."
  },
  {
    id: 387,
    question: "What is an encumbrance by deed restriction?",
    answer: "A private limitation in a deed that restricts how the property may be used or improved.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Deed restrictions are a form of private land-use control and can affect the property's value and marketability."
  },
  {
    id: 388,
    question: "What is an affirmative easement?",
    answer: "An easement that allows the holder to do something on another person's land, such as cross it.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This contrasts with a negative easement, which restricts the servient owner's use rather than allowing affirmative use."
  },
  {
    id: 389,
    question: "What is a negative easement?",
    answer: "An easement that restricts the owner of the servient estate from doing something that would otherwise be lawful.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "For example, a negative easement may prevent blocking light, air, or a view where recognized by law."
  },
  {
    id: 390,
    question: "What is a benchmark in a metes-and-bounds or survey context?",
    answer: "A permanent reference point used by surveyors to establish elevation or location measurements.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Benchmarks help surveyors tie measurements to established physical reference points."
  },
  {
    id: 391,
    question: "What is a monument in a legal description?",
    answer: "A fixed natural or artificial object used as a reference point in describing land boundaries.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Monuments can include items such as stakes, roads, streams, or marked survey points."
  },
  {
    id: 392,
    question: "What does 'metes' refer to in a metes-and-bounds description?",
    answer: "Distance measurements.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "In this system, metes refers to distance and bounds refers to directions or boundary references."
  },
  {
    id: 393,
    question: "What does 'bounds' refer to in a metes-and-bounds description?",
    answer: "The directions or boundary references that define the parcel's limits.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Bounds work together with metes to trace the parcel from the point of beginning and back again."
  },
  {
    id: 394,
    question: "What is a graduated lease?",
    answer: "A lease in which rent increases at set times or according to a stated schedule.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Graduated leases are common where parties expect inflation, rising costs, or increased property value over time."
  },
  {
    id: 395,
    question: "What is a sublease?",
    answer: "A lease in which the tenant transfers less than the entire leasehold interest to another tenant.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "In a sublease, the original tenant usually remains liable to the original landlord under the original lease."
  },
  {
    id: 396,
    question: "What is an assignment of lease?",
    answer: "A transfer by a tenant of the entire remaining leasehold interest to another party.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "This differs from a sublease because the tenant transfers the full remaining lease term rather than keeping a reversionary interest."
  },
  {
    id: 397,
    question: "What is reconciliation in appraisal?",
    answer: "The appraiser's process of weighing the different value indications and arriving at a final opinion of value.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Reconciliation does not simply average the approaches. It involves judging which approaches are most reliable for the subject property."
  },
  {
    id: 398,
    question: "What is highest and best use in appraisal?",
    answer: "The reasonably probable and legal use of property that is physically possible, financially feasible, and maximally productive.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Highest and best use is a foundational appraisal concept because value depends heavily on the most productive legal use of the property."
  },
  {
    id: 399,
    question: "What is a closing prorate for an accrued expense intended to do?",
    answer: "Charge the seller for the portion of the unpaid expense attributable to the seller's period of ownership and credit the buyer for taking over payment after closing.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "This proration logic is tested because students must understand who benefited from the expense before and after closing."
  },
  {
    id: 400,
    question: "If monthly rent is $1,850 and a tenant occupies the property for 10 months, what total rent is paid before any other charges?",
    answer: "$18,500.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply the monthly rent by the number of months. Here, $1,850 x 10 = $18,500."
  },
  {
    id: 401,
    question: "What is involuntary alienation of property?",
    answer: "A transfer of property without the owner's consent, such as through foreclosure, tax sale, condemnation, or escheat.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "This contrasts with voluntary alienation, where the owner intentionally transfers the property by deed or will."
  },
  {
    id: 402,
    question: "What is voluntary alienation of property?",
    answer: "A transfer of property made intentionally by the owner, such as by sale, gift, or will.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Voluntary alienation occurs when the owner chooses to transfer title rather than losing it by operation of law."
  },
  {
    id: 403,
    question: "What is devise in real estate?",
    answer: "The transfer of real property by will.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Students often pair devise with descent: devise is by will, while descent is by law when there is no valid will."
  },
  {
    id: 404,
    question: "What is estoppel by deed?",
    answer: "A doctrine preventing a grantor from denying the effectiveness of a deed if the grantor later acquires the interest that was purportedly conveyed.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "This concept appears in title questions where someone conveys more interest than they presently own and later acquires that missing interest."
  },
  {
    id: 405,
    question: "What is a net listing?",
    answer: "A listing arrangement in which the seller seeks a specified net amount and the broker keeps any excess as compensation, creating significant conflict-of-interest concerns.",
    category: "National Agency",
    difficulty: "hard",
    explanation: "National exams usually test net listings as ethically problematic because the broker's incentive may diverge from the seller's best interests."
  },
  {
    id: 406,
    question: "What is the difference between an amendment and an addendum to a contract?",
    answer: "An amendment changes an existing contract after it has been formed, while an addendum adds terms that become part of the agreement, often at or before execution.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Both alter the parties' written agreement, but exams often distinguish whether the change occurred before or after the original contract was finalized."
  },
  {
    id: 407,
    question: "What is an unenforceable contract?",
    answer: "A contract that may be valid in substance but cannot be enforced in court because of a legal defense such as the Statute of Frauds or expiration of the limitations period.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "This differs from a void contract, which has no legal effect from the outset."
  },
  {
    id: 408,
    question: "Which bundle-of-rights element allows an owner to sell, lease, or give away the property?",
    answer: "The right of disposition.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Disposition is the ownership right that permits transfer of all or part of the property interest."
  },
  {
    id: 409,
    question: "What is situs in real estate?",
    answer: "The economic location of property, including the characteristics of the surrounding area that influence value.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Situs is more than the physical location alone; it includes the desirability and utility of that location in the market."
  },
  {
    id: 410,
    question: "What is the appraisal principle of substitution?",
    answer: "The principle that a buyer will not pay more for a property than the cost of acquiring an equally desirable substitute.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Substitution underlies the sales comparison approach because buyers compare similar properties in the market."
  },
  {
    id: 411,
    question: "What is the appraisal principle of conformity?",
    answer: "The principle that value is maximized when a property is reasonably similar in style, quality, and use to surrounding properties.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Properties that fit their surroundings often benefit from greater market acceptance and stronger value support."
  },
  {
    id: 412,
    question: "What is the appraisal principle of progression?",
    answer: "The idea that a lesser-quality property may gain value when located among better-quality properties.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Progression is commonly tested together with regression, which is the opposite effect."
  },
  {
    id: 413,
    question: "What is the appraisal principle of regression?",
    answer: "The idea that a higher-quality property may lose value when located among lower-quality properties.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Regression shows how surrounding properties can negatively influence value."
  },
  {
    id: 414,
    question: "What is a discount point in mortgage lending?",
    answer: "A fee equal to 1 percent of the loan amount, often paid to adjust the lender's yield on the loan.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "Points are prepaid finance charges and are a standard national exam topic in mortgage-cost questions."
  },
  {
    id: 415,
    question: "What is the Real Estate Settlement Procedures Act's prohibition on kickbacks intended to prevent?",
    answer: "Referral-fee arrangements that improperly increase settlement costs or distort consumer choice in covered mortgage transactions.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "RESPA aims to protect consumers from hidden referral arrangements that affect the settlement process."
  },
  {
    id: 416,
    question: "What is a lease option?",
    answer: "A lease that gives the tenant the option, but not the obligation, to purchase the property under stated terms within a stated time.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "A lease option combines a tenancy with a purchase option, unlike a lease purchase that may obligate the tenant to buy."
  },
  {
    id: 417,
    question: "What is a lease purchase?",
    answer: "An arrangement combining a lease with an agreement that commits the tenant to purchase the property under stated terms.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "Students often confuse lease purchase with lease option. The key difference is obligation versus choice."
  },
  {
    id: 418,
    question: "What is a purchase agreement disclosure about agency intended to do generally?",
    answer: "Clarify whom the licensee represents and what duties are owed in the transaction.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "Nationally, agency-disclosure requirements vary by state, but the exam still tests the purpose of disclosing agency relationships."
  },
  {
    id: 419,
    question: "If a commission is 7% on a $280,000 sale, what is the total commission?",
    answer: "$19,600.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Multiply the sale price by the commission rate. Here, $280,000 x 0.07 = $19,600."
  },
  {
    id: 420,
    question: "What is a vested remainder?",
    answer: "A remainder interest given to an identifiable person without a condition precedent other than the natural end of the prior estate.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "A vested remainder is more secure than a contingent remainder because the remainderman is known and no additional condition must be met."
  },
  {
    id: 421,
    question: "What is a contingent remainder?",
    answer: "A future interest that depends on an uncertain event or on the identity of the remainderman becoming certain.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "The remainder is contingent if the future taker is not yet certain or if a condition precedent must occur before the interest becomes possessory."
  },
  {
    id: 422,
    question: "What is a less-than-freehold estate?",
    answer: "A leasehold estate that gives the right to possess property for a limited period without transferring ownership.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This is another way to describe a nonfreehold interest such as an estate for years or periodic tenancy."
  },
  {
    id: 423,
    question: "What is concurrent ownership?",
    answer: "Ownership of the same property by two or more parties at the same time.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Tenancy in common, joint tenancy, and in some states tenancy by the entirety are forms of concurrent ownership."
  },
  {
    id: 424,
    question: "What is severalty in property ownership?",
    answer: "Ownership by one person or one legal entity alone.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Despite the name, severalty does not mean multiple owners. It means sole ownership."
  },
  {
    id: 425,
    question: "What is a severance of tenancy by one tenant in common generally allowed to do?",
    answer: "A tenant in common may usually transfer or encumber that tenant's own undivided interest without affecting the ownership rights of the others.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This reflects the separate transferability of each tenancy in common interest."
  },
  {
    id: 426,
    question: "What is an easement by condemnation?",
    answer: "An easement created by government action under eminent domain for public use, such as utility or access purposes.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Not all public takings transfer full ownership; some create only a right to use part of the property."
  },
  {
    id: 427,
    question: "What is a party wall easement?",
    answer: "An easement giving adjoining owners reciprocal rights in a shared wall located on or near a property boundary.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Party wall rights are important in attached structures because each owner has support and use interests in the common wall."
  },
  {
    id: 428,
    question: "What is a private restriction compared with a public restriction?",
    answer: "A private restriction arises from agreements or deed covenants between private parties, while a public restriction comes from government powers such as zoning or building codes.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This distinction is heavily tested because both can limit land use but arise from different legal sources."
  },
  {
    id: 429,
    question: "What is an attachment lien?",
    answer: "A lien placed on property during litigation to preserve assets that may later be used to satisfy a judgment.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Attachment liens are provisional remedies and differ from judgment liens, which arise after judgment is entered."
  },
  {
    id: 430,
    question: "What is a writ of execution in lien enforcement?",
    answer: "A court order authorizing an officer such as a sheriff to seize and sell property to satisfy a judgment.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "This is part of judgment enforcement and commonly appears in questions about involuntary liens and creditor remedies."
  },
  {
    id: 431,
    question: "What is a homestead exemption generally intended to do?",
    answer: "Provide qualifying homeowners with some protection from certain creditors and, in some jurisdictions, tax benefits on a primary residence.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "The exact scope varies by state, but the national concept is that a principal residence may receive special legal protection."
  },
  {
    id: 432,
    question: "What is a building line or setback requirement?",
    answer: "A regulation limiting how close a building may be placed to a property line, street, or other boundary.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Setbacks are common zoning controls affecting building placement on a lot."
  },
  {
    id: 433,
    question: "What is a zoning ordinance?",
    answer: "A local law that divides land into zones and regulates permitted uses, density, setbacks, and other development standards.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "The zoning ordinance is the legal framework, while zoning maps and administrative bodies help apply it."
  },
  {
    id: 434,
    question: "What is a zoning map?",
    answer: "A map showing the boundaries of zoning districts and the locations where different zoning classifications apply.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Students should distinguish the zoning map from the zoning ordinance itself; the map shows where the rules apply."
  },
  {
    id: 435,
    question: "What is fraud in a real estate disclosure context?",
    answer: "An intentional misrepresentation or concealment of a material fact made to induce another person to rely on it.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "Fraud requires intent, which distinguishes it from negligent misrepresentation or innocent mistake."
  },
  {
    id: 436,
    question: "What is caveat emptor?",
    answer: "A doctrine meaning 'let the buyer beware,' under which buyers historically bore much of the responsibility to inspect property.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Modern disclosure laws and fraud rules have limited the reach of pure caveat emptor in many situations."
  },
  {
    id: 437,
    question: "What is a stigmatized property issue typically testing on a national exam?",
    answer: "Whether the student understands that some nonphysical conditions may affect market perception and that disclosure duties can vary by state law.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This is usually tested as a disclosure-nuance concept rather than as a uniform nationwide disclosure rule."
  },
  {
    id: 438,
    question: "What is surrender of lease?",
    answer: "The giving up of a leasehold interest by the tenant to the landlord so the lease ends before its scheduled expiration.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Surrender may be express or implied by conduct showing that both parties treat the lease as ended."
  },
  {
    id: 439,
    question: "If a property tax is $7,200 per year, what is the daily tax amount using a 360-day year?",
    answer: "$20 per day.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Divide the annual tax by 360. Here, $7,200 / 360 = $20."
  },
  {
    id: 440,
    question: "What is a freehold estate?",
    answer: "An estate in land that includes ownership rights for an uncertain duration, such as fee simple or a life estate.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Freehold estates differ from leasehold estates, which give possession for a limited time without conveying ownership."
  },
  {
    id: 441,
    question: "What is a nonfreehold estate?",
    answer: "A leasehold estate that gives possession of property for a limited period without ownership.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Nonfreehold is another term for leasehold and includes estates for years, periodic tenancies, tenancy at will, and tenancy at sufferance."
  },
  {
    id: 442,
    question: "What is a legal disability in contract or title questions?",
    answer: "A condition, such as minority or mental incapacity, that can affect a person's ability to enter into binding legal agreements.",
    category: "National Contracts",
    difficulty: "medium",
    explanation: "Legal disability questions often appear in determining whether a contract is valid, void, or voidable."
  },
  {
    id: 443,
    question: "What is a general partner's typical liability in a partnership?",
    answer: "A general partner is typically personally liable for partnership obligations.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This is relevant in ownership and business-form questions because liability differs among sole proprietorships, partnerships, corporations, and LLCs."
  },
  {
    id: 444,
    question: "What is a limited partner's typical role in a limited partnership?",
    answer: "A limited partner usually contributes capital and has limited liability, but typically does not participate in active management like a general partner.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Limited partnership questions test how ownership interests and liability exposure differ among business forms."
  },
  {
    id: 445,
    question: "What is an LLC in real estate ownership?",
    answer: "A limited liability company, a business entity that generally provides liability protection while allowing flexible ownership and management structure.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "LLCs are common in real estate ownership because they can combine operational flexibility with liability protection."
  },
  {
    id: 446,
    question: "What is color of title?",
    answer: "A claim to title based on a written instrument or record that appears valid but may actually be defective.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "Color of title often appears in questions involving adverse possession or defective conveyance."
  },
  {
    id: 447,
    question: "What is a cloud caused by an unreleased mortgage?",
    answer: "A title defect created when the public record still shows a mortgage lien that should have been removed after payoff.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "Unreleased liens can make title unmarketable until they are properly cleared from the record."
  },
  {
    id: 448,
    question: "What is the purpose of a satisfaction of mortgage?",
    answer: "To show that the mortgage debt has been paid and the lien should be released from the public record.",
    category: "National Transfer of Title",
    difficulty: "easy",
    explanation: "Paying off a loan is not enough by itself; the record should also show that the lien has been satisfied."
  },
  {
    id: 449,
    question: "What is a right of support in land ownership?",
    answer: "The right to have adjoining land support one's own land in its natural state.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Support rights often arise in boundary and excavation disputes where one owner's actions may affect neighboring land."
  },
  {
    id: 450,
    question: "What is a tax lien sale generally intended to do?",
    answer: "Collect delinquent property taxes by selling a tax lien, tax certificate, or sometimes the property itself, depending on state law.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "The exam typically focuses on the basic principle that unpaid property taxes can lead to enforced collection and loss of property rights."
  },
  {
    id: 451,
    question: "What is police power intended to protect?",
    answer: "Public health, safety, morals, and general welfare.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "This is the standard definition behind zoning, building codes, environmental regulation, and many land-use controls."
  },
  {
    id: 452,
    question: "What is a variance most commonly granted because of?",
    answer: "A qualifying hardship or practical difficulty under applicable zoning law.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "The exact legal standard varies, but the exam tests the basic idea that a variance is relief from strict application of zoning requirements."
  },
  {
    id: 453,
    question: "What is an environmental impact statement generally used for?",
    answer: "To analyze the likely environmental effects of a proposed project or governmental action before approval.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "Environmental review questions test the broader police-power role of government in land-use planning and development."
  },
  {
    id: 454,
    question: "What is a legal nonconforming use?",
    answer: "A use that lawfully existed before a zoning change and is allowed to continue even though it no longer meets current zoning requirements.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This is another way of describing a grandfathered use under zoning."
  },
  {
    id: 455,
    question: "What is a variance distinguished from?",
    answer: "A variance grants relief from zoning rules, while rezoning changes the zoning classification itself.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "This distinction is heavily tested because students often confuse an exception to the rules with a change in the rules."
  },
  {
    id: 456,
    question: "What is a stigmatized-property question often really testing?",
    answer: "Whether a candidate understands that not every psychologically affected condition is a uniform national disclosure requirement and that state law may control.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This helps students avoid overgeneralizing disclosure duties where the law varies by jurisdiction."
  },
  {
    id: 457,
    question: "What is asbestos generally considered in disclosure analysis?",
    answer: "A material environmental hazard that may need to be addressed if known and relevant to the transaction.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "National exam questions focus on recognizing asbestos as a potential hazard rather than on technical remediation procedures."
  },
  {
    id: 458,
    question: "What is the purpose of the federal Fair Housing Act's familial-status protection?",
    answer: "To prevent discrimination against households with children and certain people expecting or seeking custody of children.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Familial status is one of the core federal protected classes and is commonly tested because it is often misunderstood."
  },
  {
    id: 459,
    question: "If a property's value is $360,000 and the capitalization rate is 12%, what is the annual NOI?",
    answer: "$43,200.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "NOI equals value multiplied by capitalization rate. Here, $360,000 x 0.12 = $43,200."
  },
  {
    id: 460,
    question: "What is a principal meridian in the rectangular survey system?",
    answer: "A north-south reference line used to locate townships east or west by range.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "The principal meridian works with the base line, which runs east-west, to form the rectangular survey grid."
  },
  {
    id: 461,
    question: "What is a base line in the rectangular survey system?",
    answer: "An east-west reference line used to locate townships north or south.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "The base line and principal meridian are the starting references for legal descriptions under the government survey system."
  },
  {
    id: 462,
    question: "What is a township under the rectangular survey system?",
    answer: "A square tract of land generally measuring 6 miles on each side and containing 36 sections.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "This is a foundational survey-system concept and often appears in acreage and section questions."
  },
  {
    id: 463,
    question: "How many acres are in a quarter section of land?",
    answer: "160 acres.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "easy",
    explanation: "A section contains 640 acres, so one quarter of a section contains 160 acres."
  },
  {
    id: 464,
    question: "What is an exclusive right-to-sell listing?",
    answer: "A listing giving one broker the right to earn a commission if the property sells during the listing term, no matter who finds the buyer.",
    category: "National Agency",
    difficulty: "easy",
    explanation: "This is generally the most protective listing for the broker because the owner usually still owes the commission even if the owner finds the buyer."
  },
  {
    id: 465,
    question: "What is a multiple listing service (MLS)?",
    answer: "A cooperative information-sharing system used by participating brokers to market listings and offer compensation through the service rules.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "The MLS is not itself a type of agency, but it plays a major role in how brokers cooperate and expose listings to other professionals."
  },
  {
    id: 466,
    question: "What is the purpose of a fair housing complaint process?",
    answer: "To investigate and address alleged discriminatory housing practices and provide a legal remedy where discrimination is proven.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "National exam questions may test the idea that fair housing law includes enforcement mechanisms, not just prohibited conduct."
  },
  {
    id: 467,
    question: "What is a protected class in fair housing law?",
    answer: "A group protected by law from discrimination in housing-related activities.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Federal law defines core protected classes, and many states and localities add additional protections."
  },
  {
    id: 468,
    question: "What is discriminatory advertising in fair housing?",
    answer: "Advertising that indicates a preference, limitation, or discrimination based on a protected characteristic.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "This can violate fair housing law even before a sale or rental decision is made."
  },
  {
    id: 469,
    question: "What is the purpose of earnest money on a settlement statement?",
    answer: "To credit the buyer for deposit funds already paid toward the purchase.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Because the buyer already paid the earnest money earlier, it is typically shown as a credit to the buyer at closing."
  },
  {
    id: 470,
    question: "What is a lender credit at closing?",
    answer: "An amount the lender agrees to contribute toward a borrower's closing costs, usually in exchange for loan pricing terms.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Lender credits reduce the borrower's cash needed at closing, though they may affect the interest rate or other loan terms."
  },
  {
    id: 471,
    question: "What is a seller concession at closing?",
    answer: "An amount the seller agrees to pay or credit toward the buyer's allowable closing costs or financing expenses.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Seller concessions can make a transaction more affordable for the buyer, subject to loan-program and contract limits."
  },
  {
    id: 472,
    question: "What is gross income multiplier (GIM)?",
    answer: "A broad income multiplier found by dividing a property's sale price by its gross income, which may include more than rental income alone.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "GIM is similar to GRM but broader because GRM typically focuses only on gross rent."
  },
  {
    id: 473,
    question: "What is accrued depreciation in appraisal?",
    answer: "The total loss in value from all causes as of the effective date of the appraisal.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Accrued depreciation combines physical deterioration, functional obsolescence, and external obsolescence."
  },
  {
    id: 474,
    question: "What is a variable lease?",
    answer: "A lease in which rent may change based on an index, sales volume, expense changes, or another stated formula.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Variable leases are designed to adjust over time rather than remain fixed for the full term."
  },
  {
    id: 475,
    question: "What is a net-net-net lease, often called a triple net lease?",
    answer: "A lease in which the tenant pays rent plus property taxes, insurance, and maintenance or operating expenses as specified in the lease.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Triple net leases are common in commercial property because they shift many ownership expenses to the tenant."
  },
  {
    id: 476,
    question: "What is a release of earnest money dispute generally intended to do?",
    answer: "Resolve who is entitled to the deposit when the transaction does not close.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Earnest money disputes are common contract-and-closing problems, especially when contingencies or default issues arise."
  },
  {
    id: 477,
    question: "If a property has a sale price of $450,000 and the buyer makes a 20% down payment, what is the loan amount?",
    answer: "$360,000.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "A 20% down payment is $90,000. Subtract that from $450,000 to get a loan amount of $360,000."
  },
  {
    id: 478,
    question: "What is air right in real estate ownership?",
    answer: "The right to use, control, or transfer the space above the surface of the land, subject to law and reasonable limitations.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Air rights are part of the broader concept that ownership can include interests above and below the land surface."
  },
  {
    id: 479,
    question: "What are subsurface rights?",
    answer: "Rights to the space beneath the land surface, including rights to minerals or other underground resources where not separately conveyed.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Subsurface rights may be owned separately from surface rights, which makes them a common exam topic in ownership questions."
  },
  {
    id: 480,
    question: "What is a fixture by agreement?",
    answer: "An item treated as real or personal property based on the parties' agreement, even when physical attachment might suggest otherwise.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Exam questions often test whether a written agreement can control how an item is classified between the parties."
  },
  {
    id: 481,
    question: "What is a fee simple subject to executory limitation?",
    answer: "A defeasible fee estate that automatically shifts to a third party upon the occurrence of a stated event.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This differs from a fee simple determinable, where the estate returns to the grantor rather than shifting to someone else."
  },
  {
    id: 482,
    question: "What is a legal future interest retained by a grantor called when property may return upon breach of a condition?",
    answer: "A possibility of reverter or a right of re-entry, depending on the type of defeasible fee created.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "These interests are classic exam distinctions tied to determinable fees and fees subject to condition subsequent."
  },
  {
    id: 483,
    question: "What is a landlord's lien in general terms?",
    answer: "A lien right that may arise by law or agreement to secure unpaid rent or other tenant obligations, depending on jurisdiction.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Because landlord-lien rules vary, national exam questions usually focus on the basic concept rather than state-specific enforcement details."
  },
  {
    id: 484,
    question: "What is an income tax lien?",
    answer: "A lien imposed for unpaid income taxes that may attach to a taxpayer's property interests.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Tax liens are involuntary liens and are tested as part of creditor-priority and lien-classification questions."
  },
  {
    id: 485,
    question: "What is an inheritance tax generally based on?",
    answer: "The right to receive property from a deceased person, with liability often depending on the recipient and the jurisdiction.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "This differs conceptually from an estate tax, which is imposed on the decedent's estate before distribution."
  },
  {
    id: 486,
    question: "What is an estate tax generally based on?",
    answer: "The value of a deceased person's taxable estate before distribution to heirs or devisees.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "The exam may contrast estate taxes with inheritance taxes, which focus on the recipient rather than the estate itself."
  },
  {
    id: 487,
    question: "What is a spot zoning concern?",
    answer: "A concern that a small parcel is being zoned differently from surrounding property primarily to benefit a particular owner rather than the public plan.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Spot zoning is tested as a contrast to legitimate comprehensive planning."
  },
  {
    id: 488,
    question: "What is an amendment to a zoning ordinance?",
    answer: "A formal change to the zoning law or map that alters the regulations or classification applicable to property.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This is different from a variance, which grants relief from the ordinance without changing the ordinance itself."
  },
  {
    id: 489,
    question: "What is a conditional use or special use permit?",
    answer: "Permission to use property in a way specifically allowed by zoning if stated conditions and approval requirements are satisfied.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This differs from a variance because the use is contemplated by the ordinance, provided conditions are met."
  },
  {
    id: 490,
    question: "What is downzoning?",
    answer: "A zoning change that reduces the permitted intensity or density of land use.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Downzoning can reduce development potential and is a tested land-use term in planning and zoning questions."
  },
  {
    id: 491,
    question: "What is upzoning?",
    answer: "A zoning change that increases the permitted intensity, density, or development potential of land use.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Upzoning is often discussed as the opposite of downzoning and may affect value and permitted use."
  },
  {
    id: 492,
    question: "What is a certificate of title?",
    answer: "A statement by a title company, attorney, or authority indicating the condition of title after examination of the record.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "A certificate of title differs from title insurance because it is an opinion or certification rather than an insurance policy against certain losses."
  },
  {
    id: 493,
    question: "What is a title defect created by a forged deed?",
    answer: "A forged deed generally creates a serious title defect because a forged conveyance is not effective to transfer valid title.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "Forgery is a classic title problem because even subsequent parties may face defects if the chain of title includes an invalid deed."
  },
  {
    id: 494,
    question: "What is an unrecorded deed's main risk?",
    answer: "It may be valid between the parties but can lose priority to a later purchaser or creditor protected by the recording laws.",
    category: "National Transfer of Title",
    difficulty: "medium",
    explanation: "This is why recording is important even when the deed itself has already been delivered."
  },
  {
    id: 495,
    question: "What is inverse condemnation?",
    answer: "A claim by a property owner that government action has effectively taken property rights without formal condemnation or just compensation.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Inverse condemnation flips the usual eminent-domain process because the owner brings the claim rather than the government initiating condemnation."
  },
  {
    id: 496,
    question: "What is the difference between a lease and a license in property law?",
    answer: "A lease gives the right to exclusive possession for a term, while a license is merely permission to use property without creating a leasehold estate.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "This distinction matters because a license usually provides fewer possessory rights and less legal protection than a lease."
  },
  {
    id: 497,
    question: "If a 160-acre tract is sold at $3,200 per acre, what is the total price?",
    answer: "$512,000.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Multiply the acreage by the per-acre price. Here, 160 x $3,200 = $512,000."
  },
  {
    id: 498,
    question: "What is a fixture by intention?",
    answer: "An item that may be considered a fixture because the parties intended it to become a permanent part of the property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Intent is one of the most important fixture tests because courts often look at whether the item was meant to remain with the property."
  },
  {
    id: 499,
    question: "What is a condition precedent in a future-interest context?",
    answer: "A condition that must occur before an estate or interest becomes possessory or enforceable.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This concept often appears in contingent-remainder questions because the future interest depends on an event occurring first."
  },
  {
    id: 500,
    question: "What is the difference between a vested remainder and a reversion?",
    answer: "A vested remainder passes to a third party after the prior estate ends, while a reversion returns the property to the grantor or the grantor's heirs.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This is a classic future-interest distinction because both follow a prior estate but go to different parties."
  },
  {
    id: 501,
    question: "What is a concurrent estate?",
    answer: "An estate held by two or more persons at the same time.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "This is another way to describe forms of shared ownership such as tenancy in common or joint tenancy."
  },
  {
    id: 502,
    question: "What is a unity of possession?",
    answer: "The principle that each co-owner has an equal right to possess and use the whole property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Unity of possession is essential to common forms of co-ownership and helps explain why co-owners share rights in the entire parcel."
  },
  {
    id: 503,
    question: "What is an easement for ingress and egress?",
    answer: "An easement that provides the right to enter and exit property across another parcel.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "This is one of the most common practical easement types because it deals with access."
  },
  {
    id: 504,
    question: "What is a utility easement?",
    answer: "An easement allowing a utility company to install, maintain, or repair utility lines or facilities on the property.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "Utility easements are commonly easements in gross because they benefit the company rather than a neighboring parcel."
  },
  {
    id: 505,
    question: "What is a negative covenant in land use?",
    answer: "A promise restricting the owner from certain uses or actions on the property.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Negative covenants are private restrictions and often appear in subdivision deed restrictions or restrictive covenant questions."
  },
  {
    id: 506,
    question: "What is external depreciation in appraisal usually caused by?",
    answer: "Negative influences outside the property, such as neighborhood decline, nuisance conditions, or adverse nearby land uses.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "External depreciation is generally considered difficult or impossible for the owner alone to cure because the cause is outside the property."
  },
  {
    id: 507,
    question: "What is the appraisal principle of anticipation?",
    answer: "The principle that value is created by the expectation of future benefits such as income or utility.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "This principle is central to investment-property valuation because buyers pay for expected future benefits."
  },
  {
    id: 508,
    question: "What is the appraisal principle of contribution?",
    answer: "The principle that the value of a component is measured by how much it adds to or subtracts from the value of the whole property.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "Contribution explains why the cost of an improvement does not always equal the amount of value it adds."
  },
  {
    id: 509,
    question: "What is the difference between fair housing steering and lawful client service?",
    answer: "Steering unlawfully directs clients based on protected characteristics, while lawful service responds to objective client criteria without discriminatory assumptions.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "This distinction is important because agents must provide service without channeling clients by race, religion, familial status, or other protected categories."
  },
  {
    id: 510,
    question: "What is a handicap or disability accommodation question usually testing in fair housing?",
    answer: "Whether the candidate can distinguish lawful equal-access accommodations from discriminatory refusal or unequal treatment.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "These questions often turn on whether a rule, service, or policy change is needed for equal housing opportunity."
  },
  {
    id: 511,
    question: "What is a discriminatory statement in advertising?",
    answer: "A statement that expresses a preference, limitation, or exclusion based on a protected characteristic.",
    category: "National Fair Housing and Disclosures",
    difficulty: "easy",
    explanation: "Advertising alone can violate fair housing law even if no completed transaction occurs."
  },
  {
    id: 512,
    question: "What is a known material defect disclosure question generally asking?",
    answer: "Whether the licensee must avoid concealment and disclose a known condition that would matter to a reasonable buyer or tenant.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "National exam questions usually focus on the duty not to hide known material problems."
  },
  {
    id: 513,
    question: "What is an environmental hazard question often testing on the national exam?",
    answer: "Whether the candidate can identify a potentially material health or safety condition without assuming the licensee should act as an environmental expert.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "The exam often tests recognition and disclosure principles rather than specialized remediation advice."
  },
  {
    id: 514,
    question: "What is a closing escrow account generally used for?",
    answer: "To hold funds or documents until the conditions of the closing or settlement are satisfied.",
    category: "National Leases and Closing",
    difficulty: "medium",
    explanation: "Escrow arrangements help ensure that all parties perform before money or documents are released."
  },
  {
    id: 515,
    question: "What is a possession date issue at closing typically about?",
    answer: "Determining when the buyer gains the legal right to occupy the property under the contract or settlement terms.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Possession does not always transfer at the same moment as closing unless the agreement says so."
  },
  {
    id: 516,
    question: "What is actual authority in agency law?",
    answer: "Authority the principal intentionally gives the agent, either expressly or by implication.",
    category: "National Agency",
    difficulty: "medium",
    explanation: "Actual authority is different from apparent authority, which arises from appearances to third parties."
  },
  {
    id: 517,
    question: "If a 3,600-square-foot building is rented at $22 per square foot per year, what is the annual rent?",
    answer: "$79,200.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Multiply the square footage by the annual rate per square foot. Here, 3,600 x $22 = $79,200."
  },
  {
    id: 518,
    question: "What is a dominant tenement?",
    answer: "The parcel of land that benefits from an easement appurtenant.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "In an easement appurtenant, the dominant tenement receives the benefit and the servient tenement bears the burden."
  },
  {
    id: 519,
    question: "What is a servient tenement?",
    answer: "The parcel of land that is burdened by an easement appurtenant.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "The servient land owner must allow the easement use, while the dominant parcel receives the benefit."
  },
  {
    id: 520,
    question: "What is an easement by implication?",
    answer: "An easement inferred from the circumstances of a prior land use when the parties did not expressly create it in writing.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Implied easements often arise when a parcel is divided and the prior use suggests continued access or utility is intended."
  },
  {
    id: 521,
    question: "What is the distinction between real rights and personal rights in property?",
    answer: "Real rights attach to the property itself, while personal rights are enforceable only against specific people.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This distinction helps explain why some interests run with the land and others do not."
  },
  {
    id: 522,
    question: "What is a corporeal interest in real estate?",
    answer: "A tangible, physical ownership interest in land or improvements.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "Corporeal interests involve physical property, while incorporeal interests involve nonphysical rights such as easements."
  },
  {
    id: 523,
    question: "What is an incorporeal interest in real estate?",
    answer: "A nonphysical interest in land, such as an easement or other intangible property right.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This term appears in classic property-law questions that distinguish physical ownership from rights in land."
  },
  {
    id: 524,
    question: "What is a leasehold interest's main legal characteristic?",
    answer: "It grants the right of possession and use for a time, but not title ownership.",
    category: "National Property Ownership and Interests",
    difficulty: "easy",
    explanation: "Leasehold interests are nonfreehold estates because they are based on possession rather than ownership."
  },
  {
    id: 525,
    question: "What is a fee estate's main legal characteristic?",
    answer: "It is a freehold ownership estate that may be inheritable and can last indefinitely, subject to its terms.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "Fee estates contrast with leasehold estates, which are based on possession for a limited term."
  },
  {
    id: 526,
    question: "What is a credit entry for the seller on a settlement statement intended to show?",
    answer: "An amount the seller is entitled to receive or be credited for in the closing accounting.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Credits increase what the seller receives or reduce what the seller owes at closing."
  },
  {
    id: 527,
    question: "What is a debit entry for the buyer on a settlement statement intended to show?",
    answer: "An amount charged to the buyer in the closing accounting.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "Debits increase the buyer's cost or the cash the buyer must bring to closing."
  },
  {
    id: 528,
    question: "What is a point in mortgage lending?",
    answer: "A fee equal to 1 percent of the loan amount.",
    category: "National Financing",
    difficulty: "easy",
    explanation: "Points are often used to express loan-origination charges or discount charges as a percentage of the loan."
  },
  {
    id: 529,
    question: "What is the distinction between discount points and origination points?",
    answer: "Discount points are generally used to adjust the lender's yield, while origination points are generally charged for making the loan.",
    category: "National Financing",
    difficulty: "medium",
    explanation: "The exam often tests whether candidates understand that not all points serve the same purpose."
  },
  {
    id: 530,
    question: "What is the federal Fair Housing Act's disability protection generally concerned with?",
    answer: "Preventing unequal treatment and requiring equal housing opportunity for persons with disabilities under applicable law.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "Disability questions often involve reasonable accommodations, reasonable modifications, and prohibited discriminatory refusals."
  },
  {
    id: 531,
    question: "What is a testing program in fair housing enforcement?",
    answer: "An investigative method using paired or otherwise structured inquiries to detect discriminatory treatment in housing transactions.",
    category: "National Fair Housing and Disclosures",
    difficulty: "hard",
    explanation: "Testing is a recognized enforcement tool because discrimination may appear only when comparable applicants are treated differently."
  },
  {
    id: 532,
    question: "What is a patent ambiguity in a contract or deed?",
    answer: "An uncertainty that is apparent on the face of the document itself.",
    category: "National Contracts",
    difficulty: "hard",
    explanation: "Patent ambiguity differs from latent ambiguity, which becomes apparent only when applying the document to external facts."
  },
  {
    id: 533,
    question: "What is a latent ambiguity in a contract or deed?",
    answer: "An uncertainty not obvious from the document alone but revealed when the language is applied to the facts.",
    category: "National Contracts",
    difficulty: "hard",
    explanation: "This concept is tested because apparently clear wording can still produce uncertainty when matched to real-world circumstances."
  },
  {
    id: 534,
    question: "What is a township tier in the rectangular survey system?",
    answer: "A row of townships running east-west and identified by how far north or south it lies from the base line.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "This is a more technical rectangular-survey term that helps candidates read full legal descriptions accurately."
  },
  {
    id: 535,
    question: "What is a range strip in the rectangular survey system?",
    answer: "A column of townships running north-south and identified by how far east or west it lies from the principal meridian.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "hard",
    explanation: "Like township tiers, range strips help organize the survey grid into labeled rows and columns."
  },
  {
    id: 536,
    question: "What is the appraiser's effective date of value?",
    answer: "The specific date as of which the appraiser's opinion of value applies.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "An appraisal opinion is always tied to a stated date because market value can change over time."
  },
  {
    id: 537,
    question: "If a broker is entitled to a 2.5% side of the commission on a $640,000 sale, how much is that side?",
    answer: "$16,000.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Multiply $640,000 by 0.025 to get $16,000."
  },
  {
    id: 538,
    question: "What is an estate in reversionary possession?",
    answer: "An interest in which ownership returns to the grantor after a lesser estate ends and the grantor regains possession.",
    category: "National Property Ownership and Interests",
    difficulty: "hard",
    explanation: "This reinforces the difference between future interests returning to the grantor and those passing to a third party."
  },
  {
    id: 539,
    question: "What is a legal estate in possession?",
    answer: "An estate in which the owner presently has the right to possess and enjoy the property.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This contrasts with a future interest, where possession is postponed until a later event."
  },
  {
    id: 540,
    question: "What is a tenancy in common owner's share if a deed creates co-ownership but does not specify equal shares?",
    answer: "The owners may still hold unequal shares if that is indicated by the deed or circumstances; tenancy in common does not require equal ownership interests.",
    category: "National Property Ownership and Interests",
    difficulty: "medium",
    explanation: "This is a common exam distinction from joint tenancy, which usually requires equal interests."
  },
  {
    id: 541,
    question: "What is an appurtenant easement's main characteristic?",
    answer: "It benefits a parcel of land and generally runs with that land when ownership transfers.",
    category: "National Encumbrances and Liens",
    difficulty: "easy",
    explanation: "This emphasizes why an easement appurtenant is tied to the land rather than to a specific person."
  },
  {
    id: 542,
    question: "What is a personal easement's main characteristic?",
    answer: "It benefits a person or entity rather than a parcel of land and is often treated as an easement in gross.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Utility easements are common examples because the benefit belongs to the company, not an adjoining parcel."
  },
  {
    id: 543,
    question: "What is a general warranty of quiet enjoyment in a deed context?",
    answer: "A covenant that the grantee's possession will not be disturbed by someone with superior title.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "This is one of the classic deed covenants tested with warranty deeds and title assurances."
  },
  {
    id: 544,
    question: "What is a covenant of further assurance in a deed?",
    answer: "A promise that the grantor will perform future acts needed to perfect the grantee's title if necessary.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "This covenant supports the grantee if additional documents or actions are needed to clear title."
  },
  {
    id: 545,
    question: "What is a special assessment lien generally tied to?",
    answer: "A public improvement that specially benefits a particular property, such as paving, sidewalks, or sewer installation.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This differs from a general ad valorem tax because it is imposed for a specific improvement rather than general revenue."
  },
  {
    id: 546,
    question: "What is a general tax rate in property taxation used to determine?",
    answer: "The amount of tax owed based on the property's assessed value.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "Tax-rate questions often appear with assessed value and mill-rate style calculations."
  },
  {
    id: 547,
    question: "What is a mill rate in property taxation?",
    answer: "A tax rate expressed in mills, where one mill equals one dollar of tax per one thousand dollars of assessed value.",
    category: "National Encumbrances and Liens",
    difficulty: "hard",
    explanation: "Mill-rate concepts are common in national math and tax questions because they connect assessed value to tax owed."
  },
  {
    id: 548,
    question: "What is a zoning variance intended not to do?",
    answer: "It is not intended to rewrite the zoning ordinance or permanently reclassify the property.",
    category: "National Land Use and Legal Descriptions",
    difficulty: "medium",
    explanation: "This reinforces the distinction between a variance and rezoning."
  },
  {
    id: 549,
    question: "What is a deed restriction intended not to do?",
    answer: "It does not operate as a public zoning law; it is a private land-use restriction.",
    category: "National Encumbrances and Liens",
    difficulty: "medium",
    explanation: "This helps distinguish private restrictions from government land-use controls."
  },
  {
    id: 550,
    question: "What is a lease's term of years intended to establish?",
    answer: "A definite period of possession with a fixed beginning and ending date.",
    category: "National Leases and Closing",
    difficulty: "easy",
    explanation: "This restates the core feature of an estate for years in a more practical lease-drafting context."
  },
  {
    id: 551,
    question: "What is constructive notice by possession?",
    answer: "Notice a buyer may be charged with when someone is visibly occupying or using the property in a way that suggests rights may exist.",
    category: "National Transfer of Title",
    difficulty: "hard",
    explanation: "Public records are not the only source of notice; visible possession can also require further inquiry."
  },
  {
    id: 552,
    question: "What is the purpose of an estoppel certificate in leasing or title review?",
    answer: "To confirm key facts about an existing lease or occupancy situation so another party can rely on them.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "Estoppel certificates are often used in sales or financing of leased property to verify lease terms and tenant claims."
  },
  {
    id: 553,
    question: "What is market data in appraisal?",
    answer: "Information from actual market transactions and conditions used to estimate value.",
    category: "National Valuation and Math",
    difficulty: "easy",
    explanation: "Comparable sales, listing trends, and market activity are examples of market data used in valuation."
  },
  {
    id: 554,
    question: "What is an arm's-length transaction?",
    answer: "A transaction between unrelated parties, each acting in their own best interest without undue pressure or special relationship.",
    category: "National Valuation and Math",
    difficulty: "medium",
    explanation: "Appraisers prefer arm's-length sales as comparables because they better reflect true market value."
  },
  {
    id: 555,
    question: "What is a disclosure requirement for known environmental contamination generally testing?",
    answer: "Whether the licensee understands the duty to disclose a known material condition without acting as an environmental expert.",
    category: "National Fair Housing and Disclosures",
    difficulty: "medium",
    explanation: "The test focus is usually on recognition and disclosure of known material hazards, not technical remediation advice."
  },
  {
    id: 556,
    question: "What is a settlement prorate for prepaid rent generally intended to do?",
    answer: "Credit the seller or landlord for rent already collected that covers time after closing, while charging the buyer for that future benefit.",
    category: "National Leases and Closing",
    difficulty: "hard",
    explanation: "Prepaid items are prorated differently from accrued items because the money was already paid before closing."
  },
  {
    id: 557,
    question: "If a property is assessed at $250,000 and the tax rate is 24 mills, what is the annual property tax?",
    answer: "$6,000.",
    category: "National Valuation and Math",
    difficulty: "hard",
    explanation: "A 24-mill rate means $24 per $1,000 of assessed value. $250,000 / 1,000 = 250, and 250 x $24 = $6,000."
  }
];
